const translations = {
  en: {
    dateTimePicker: {
      title: "Select Date & Time",
      durationHeading: "Duration in hours:",
      durationDay: "Day",
      actions: {
        cancel: "Cancel",
        save: "Save",
      },
    },
    auth: {
      language: {
        label: {
          en: "EN",
          de: "DE",
        },
        switchToGerman: "Switch to German",
        switchToEnglish: "Switch to English",
      },
      fields: {
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm password",
        countryCode: "Country code",
      },
      password: {
        show: "Show password",
        hide: "Hide password",
      },
      loading: {
        checkingSession: "Checking your session...",
        checkingAccess: "Checking access...",
      },
      media: {
        loginAlt: "Person preparing to paddle",
        registerAlt: "Friends preparing to paddle boards",
        resetAlt: "Wayli user resetting password",
      },
      register: {
        eyebrow: "Join the crew",
        title: "Create your Wayli account",
        lead:
          "Save your favourite spots, earn rewards, and get paddle-ready updates.",
        termsPrefix: "I agree to the",
        termsLink: "Legal policies",
        termsSuffix: ".",
        primaryCta: "Sign up",
        googleCta: "Sign up with Google",
        footer: {
          text: "Already have an account?",
          link: "Log in",
        },
      },
      login: {
        eyebrow: "Welcome back",
        title: "Log in to Wayli",
        lead: "Pick up your next paddle plan right where you left off.",
        rememberMe: "Remember me",
        forgotPassword: "Forgot password?",
        primaryCta: "Log in",
        googleCta: "Continue with Google",
        footer: {
          text: "Don't have an account?",
          link: "Create one",
        },
      },
      forgotPassword: {
        eyebrow: "Reset access",
        title: "Recover your Wayli password",
        lead:
          "Enter the email connected to your account and we'll send you a reset link.",
        successHeading: "Check your inbox",
        successMessage:
          "We've sent a password reset link to {email}. The link expires in 30 minutes, so be sure to use it soon.",
        successRetry: "Didn't get the email? Check your spam folder or",
        successRetryCta: "try again",
        resendCta: "resend now",
        resendCountdown: "resend in {time}",
        resendSending: "Resending...",
        resendCountdownMessage: "You can resend a reset link in {time}.",
        changeEmailCta: "use a different email",
        errorMessage: "Something went wrong. Please try again in a moment.",
        submit: {
          default: "Send reset link",
          sending: "Sending...",
        },
        footer: {
          text: "Remember your password?",
          link: "Back to login",
        },
      },
    },
    header: {
      logoAlt: "Wayli logo",
      nav: {
        price: "PRICE",
        booking: "BOOKING",
        faq: "FAQ",
        info: "INFO",
      },
      actions: {
        switchToGerman: "Switch to German",
        switchToEnglish: "Switch to English",
      },
      languageLabel: {
        en: "EN",
        de: "DE",
      },
    },
    footer: {
      heading: {
        line1: "Let’s",
        highlight: "Paddle",
        line2: "Together",
      },
      paragraph:
        "Wayli SUP & Kayak Rentals – We make water adventures easy, safe, and seriously fun. Stable boards, fresh gear, and a crew that loves the water as much as you will. Whether it’s your first time or your hundredth paddle, we’ve got routes, tips, and good vibes waiting.",
      links: {
        privacy: "Legal Information",
        cookies: "Cookie",
      },
    },
    cookieBanner: {
      eyebrow: "Cookie settings",
      title: "Choose how Wayli uses cookies",
      lead:
        "We use necessary cookies to keep sign-in, booking recovery, and basic preferences working. Choose necessary plus functional features for maps, or allow all to also enable site analytics.",
      footnote: "You can change this any time from the footer.",
      actions: {
        reject: "Only necessary",
        acceptFunctional: "Necessary + functional",
        customize: "Choose settings",
        save: "Save choices",
        accept: "All",
        close: "Close cookie settings",
      },
      categories: {
        necessary: {
          label: "Necessary",
          summary: "Sign-in, booking recovery, language, and your consent choice.",
          title: "Always active",
          badge: "Required",
          description:
            "Needed for login state, booking recovery after payment redirects, language preference, and saving your cookie choice.",
        },
        functional: {
          label: "Functional",
          summary: "Google Maps and similar optional features.",
          title: "Maps and helpers",
          description:
            "Allows Wayli to load embedded Google Maps when you want the map view.",
          toggle: "Toggle functional cookies",
        },
        analytics: {
          label: "Analytics",
          summary: "Visit measurement for our own traffic reports.",
          title: "Site analytics",
          description:
            "Allows Wayli to measure page visits using a local identifier and technical visit data sent to our server.",
          toggle: "Toggle analytics cookies",
        },
      },
    },
    home: {
      hero: {
        headingLine1: "Ride the Waves.",
        headingLine2: "Your Water Adventure",
        headingLine3: "Starts Here.",
        description:
          "Rent SUP boards, kayaks, and gear in minutes — no hassle. Available daily. Perfect for beginners and pros.",
        cta: "Book Now",
        imageAlt: "SUP rider",
      },
    },
    bookingNight: {
      title: "Moonlight Paddle Adventure",
      locationHeading: "Select Night Location",
      gearHeading: "Choose Your Glow Gear",
      controls: {
        previous: "Previous",
        next: "Next",
        finish: "Finish",
      },
      location: {
        description:
          "Pick the glow base that fits your vibe — see the map and tonight's hours.",
        selectPrompt: "Select a base to see it on the map and check tonight's hours.",
      },
      validation: {
        selectLocation: "Please select a location before continuing.",
        selectEquipment: "Please select at least one item.",
      },
      locations: {
        lake_vienna: "Lake Vienna",
        danube_riverside: "Danube Riverside",
        mountain_lake: "Mountain Lake",
      },
      items: {
        priceFallback: "Free",
        neon_board: {
          title: "Neon Glide Board",
          description: "LED-lit SUP, paddle, life vest, dry bag",
        },
      },
      summary: {
        heading: "Your Night Booking",
        durationNight: "Night (flex)",
        note:
          "Please verify your details before paying. You’ll receive a confirmation email right after a successful payment.",
        total: "Total Price",
        equipmentFallback: "No gear selected",
      },
      aria: {
        add: "Add {item}",
        remove: "Remove {item}",
      },
      payment: {
        successMessage: "Your night ride is confirmed. Check your inbox for details.",
        contact: {
          invalidEmail: "Please enter a valid email address.",
        },
      },
      media: {
        confirmationAlt: "Night booking confirmation",
      },
    },
    bookingAction: {
      status: {
        reserved: "Reserved",
        inUse: "In use",
        completed: "Completed",
        cancelled: "Cancelled",
        unknown: "Unknown",
      },
      actions: {
        checkout: "Check out",
        returned: "Returned",
      },
      hero: {
        eyebrow: "Wayli partner scan",
        title: "Booking QR action",
        subhead:
          "This page shows a single booking. Actions require a verified location or admin PIN.",
      },
      loading: "Loading booking details...",
      errorTitle: "Unable to load booking",
      errors: {
        missingToken: "Missing booking token.",
        expired: "This booking link has expired or been revoked.",
        invalid: "This booking link is invalid.",
        loadFailed: "We couldn't load this booking.",
        pinLength: "Enter a 4-6 digit access PIN.",
        tooManyAttempts: "Too many failed attempts. Please wait and try again.",
        pinFailed: "PIN validation failed.",
      },
      success: {
        checkedOut: "Checked out",
        checkedIn: "Checked in",
        suffix: "successfully",
      },
      summary: {
        qrValidUntil: "QR valid until",
        equipment: "Equipment",
        noEquipment: "No equipment listed.",
        time: "Time",
        pickupLocation: "Pickup location",
        locationFallback: "Pickup location",
        noActions: "No actions are available for this booking right now.",
      },
      pin: {
        title: "Access PIN required",
        lead: "Enter the location PIN or the global admin PIN to confirm this action.",
        label: "Access PIN",
        cancel: "Cancel",
        checking: "Checking...",
        confirm: "Confirm",
      },
    },
    bookingDay: {
      title: "Book Your Adventure",
      eventCheckout: {
        title: "Book Your Event",
        heading: "Your event summary",
        event: "Event",
        guests: "Guests",
        capacity: "Capacity",
        bookedCount: "{booked} booked of {total} places",
        successTitle: "Event payment successful!",
        successMessage: "Your event payment is complete. We’ll follow up with the event details.",
      },
      steps: {
        location: "Select Location",
        equipment: "Choose Equipment",
        dateTime: "Dates & Time",
        confirmation: "Confirmation",
      },
      controls: {
        previous: "Previous",
        next: "Next",
        finish: "Finish",
      },
      validation: {
        blockedPickupReturn: "Pickup or return is not available on one of the selected dates.",
      },
      availability: {
        checking: "Checking availability…",
        available: "Great news! Your selected gear is available.",
        unavailableShort: "Some gear is unavailable. Try another slot or adjust quantities.",
        unavailableDates:
          "Selected gear is fully booked on {dates}. Please choose other dates or reduce quantities.",
        unavailableInfoLabel: "Show unavailable gear details",
        unavailableListTitle: "Unavailable",
        need: "Need",
        have: "Avail",
        unavailableOn: "Blocked on",
        unknownEquipment: "Equipment",
      },
      voucher: {
        label: "Voucher / promo code",
        title: "Voucher / promo code",
        ready: "Unlocked",
        locked: "Earn after 5 rides",
        placeholder: "Enter voucher code",
        apply: "Apply",
        appliedLabel: "Applied",
        remove: "Remove",
        none: "No reward voucher is available yet. Earn one after 5 completed rides.",
        enterCode: "Enter a voucher code.",
        invalid: "This code isn't valid.",
        applied: "Reward applied! €20 discount added.",
        promoApplied: "Promo applied!",
        promoRedeemed: "This promo code has already been redeemed.",
        promoUnavailable: "This promo code is no longer available.",
        lost: "Reward voucher unavailable. Please try another code.",
        redeemed: "This voucher has already been redeemed.",
        checkFailed: "We couldn't validate that voucher. Please try again.",
        authRequired: "Please log in to use a reward voucher.",
        discountLine: "Reward applied: -€{amount}",
        originalTotal: "Before reward: €{amount}",
        discountLinePromo: "Promo applied: -€{amount}",
        originalTotalPromo: "Before promo: €{amount}",
      },
      payment: {
        missingIntent: "Missing Stripe payment intent.",
        intentMismatch: "Payment intent does not match the pending booking.",
        stillProcessing:
          "Payment is still processing. Please check back in a moment.",
        notCompleted: "Payment has not completed.",
        contact: {
          invalidEmail: "Please enter a valid email address.",
        },
      },
      media: {
        confirmationAlt: "Booking confirmation",
      },
      range: {
        title: "Choose your rental range",
        start: "Start",
        end: "End",
        startShort: "Start",
        endShort: "End",
        bridgePending: "Select dates",
        bridgeStart: "Pick end date",
        bridgeHours: "{hours} h",
        bridgeDay: "{count} day",
        bridgeDays: "{count} days",
      },
      summary: {
        heading: "Your Booking Summary",
        location: "Location",
        start: "Start",
        end: "End",
        duration: "Duration",
        equipment: "Equipment",
        noneSelected: "Not selected",
        equipmentFallback: "No equipment selected",
        durationDaysSingle: "1 day",
        durationDaysPlural: "{count} days",
        durationDaysDecimal: "{count} days",
        total: "Total Price",
        note:
          "Please verify your details before paying. You’ll receive a booking email with all details and instructions right after a successful payment.",
        legalPrefix:
          "By proceeding with payment, you confirm that you have read and agree to the",
        legalLink: "Legal Information",
        legalSuffix:
          "including the Terms and Conditions, cancellation policy, and safety rules, which govern your booking.",
        priceBanner: "Your rental price: €{price}",
      },
      items: {
        priceFallback: "Free",
      },
    },
    infoPage: {
      hero: {
        eyebrow: "Plan your paddle",
        heading: "Everything you need before you hit the water",
        description:
          "Opening hours, launch spots and how to reach us. Settle all the details, then roll up ready to float.",
        primaryCta: "Book a ride",
        secondaryCta: "View FAQ",
        imageAlt: "Wayli crew preparing SUP boards by the water",
      },
      highlights: [
        {
          title: "Flexible launch windows",
          description: "Morning, afternoon and sunset paddles every day of the week.",
        },
        {
          title: "Boards & kayaks tuned",
          description: "Freshly rinsed gear, glow-night kits, and optional extras to level up.",
        },
        {
          title: "Delivery on request",
          description:
            "Delivery to your address can be arranged by email or WhatsApp for €5, subject to agreement.",
        },
      ],
      events: {
        eyebrow: "Events",
        title: "Upcoming water sessions",
        book: "Book now",
        controls: "Scroll events",
        previous: "Previous events",
        next: "Next events",
        modal: {
          eventDetails: "Event details",
          time: "Time",
          location: "Location",
          openMaps: "Open in Google Maps",
          duration: "Duration",
          availability: "Availability",
          bookedCount: "{booked} booked of {total} places",
          left: "left",
          total: "Total",
          included: "Included",
          pickupReturn: "Choose pickup and return",
          pickupReturnHint: "Select when you want to pick up your board and when you will return it.",
          pickup: "Pickup",
          return: "Return",
          invalidPickupReturn: "Return time must be after pickup time, and both times must be inside the event window.",
          request: "Request booking",
        },
        items: {
          sunset: {
            title: "Sunset Paddle Social",
            description:
              "A relaxed golden-hour group paddle with easy pace, photo stops, and calm-water routing.",
            detail:
              "Best for small groups, first-time paddlers, and anyone who wants a low-pressure evening on the water.",
            location: "Danube Riverside",
            duration: "2 hours",
            capacity: "Up to 10 guests",
            price: "From EUR 24",
            included: [
              "SUP or kayak setup, paddle, life vest, and dry bag.",
              "Short safety briefing and route recommendation.",
              "Photo break at the calmest point of the route.",
            ],
          },
          family: {
            title: "Family Morning Paddle",
            description:
              "A quieter morning slot for families and mixed-experience groups who want clear timing and stable gear.",
            detail:
              "We keep the route simple, fit vests before launch, and help families pick the right board or kayak.",
            location: "Lake Vienna",
            duration: "90 minutes",
            capacity: "Up to 8 guests",
            price: "From EUR 18",
            included: [
              "Stable boards or kayaks selected for your group.",
              "Kid-sized life vests where needed.",
              "Simple pickup and return flow at the launch point.",
            ],
          },
          glow: {
            title: "Glow Night Session",
            description:
              "A limited evening session with glow gear, darker water, and a more atmospheric group route.",
            detail:
              "Designed for confident swimmers who want a memorable night paddle with a small supervised crew.",
            location: "Danube Riverside",
            duration: "2 hours",
            capacity: "Up to 6 guests",
            price: "From EUR 34",
            included: [
              "LED SUP setup, paddle, vest, and dry bag.",
              "Night-specific safety briefing before launch.",
              "Small group size for a calmer route.",
            ],
          },
          coffee: {
            title: "Coffee Cruise",
            description:
              "An easy late-morning paddle with a calm route and time to reset before the day gets busy.",
            detail:
              "A low-intensity session for guests who want clear instruction, relaxed timing, and a short route.",
            location: "Lake Vienna",
            duration: "75 minutes",
            capacity: "Up to 7 guests",
            price: "From EUR 16",
            included: [
              "Stable SUP setup with paddle, vest, and dry bag.",
              "Beginner-friendly pace and route briefing.",
              "Optional cafe stop recommendation after return.",
            ],
          },
          team: {
            title: "Team Paddle Hour",
            description:
              "A compact team format for colleagues or friends who want shared gear and simple coordination.",
            detail:
              "Built for teams that want a social activity without a complicated route, deposit, or long briefing.",
            location: "Danube Riverside",
            duration: "90 minutes",
            capacity: "Up to 12 guests",
            price: "From EUR 22",
            included: [
              "Mixed SUP and kayak setup based on group size.",
              "Shared route plan and return timing.",
              "Group check-in support at the launch point.",
            ],
          },
          skills: {
            title: "Balance Skills Clinic",
            description:
              "A focused SUP session for improving stance, turns, remounts, and confidence close to shore.",
            detail:
              "Good for returning paddlers who want better control before booking longer self-guided routes.",
            location: "Lake Vienna",
            duration: "90 minutes",
            capacity: "Up to 6 guests",
            price: "From EUR 28",
            included: [
              "SUP board, paddle, vest, and dry bag.",
              "Technique-focused briefing before launch.",
              "Small group size for more individual feedback.",
            ],
          },
          discovery: {
            title: "Kayak Discovery",
            description:
              "A short guided kayak route for guests who want stable seating and simple paddling technique.",
            detail:
              "Ideal for guests who prefer kayaking over standing on a SUP, with a route kept close to shore.",
            location: "Lake Vienna",
            duration: "2 hours",
            capacity: "Up to 9 guests",
            price: "From EUR 25",
            included: [
              "Single or double kayak, paddle, vest, and dry bag.",
              "Basic steering and route briefing.",
              "Calm-water route selected for the day.",
            ],
          },
          afterWork: {
            title: "After Work Reset",
            description:
              "A clean one-hour reset after work with fast check-in, ready gear, and an easy return window.",
            detail:
              "Designed for people who want a short water break without committing to a full evening session.",
            location: "Danube Riverside",
            duration: "60 minutes",
            capacity: "Up to 10 guests",
            price: "From EUR 14",
            included: [
              "Fast pickup with SUP or kayak setup.",
              "Compact route recommendation.",
              "Return support before closing time.",
            ],
          },
        },
      },
      hours: {
        title: "Working hours",
        description: "Time slots designed around calm waters and golden-hour light.",
        rows: {
          weekday: {
            label: "Monday – Friday",
            value: "08:00 – 20:00",
          },
          saturday: {
            label: "Saturday",
            value: "09:00 – 18:00",
          },
          sunday: {
            label: "Sunday & Holidays",
            value: "Closed (private groups on request)",
          },
        },
      },
      contact: {
        title: "Stay in touch",
        description:
          "Need to tweak your booking, add extra boards, or ask for a guide? We’re one tap away.",
        items: {
          phone: {
            label: "Give us a call",
            value: "+43 123 456 789",
          },
          email: {
            label: "Drop a message",
            value: "wayli@wayli.eu",
          },
          whatsapp: {
            label: "Chat on WhatsApp",
            value: "wayli whatsapp",
          },
          instagram: {
            label: "Follow the vibes",
            value: "@wayli.eu",
          },
          tiktok: {
            label: "Join our community",
            value: "tiktok.com/@wayli.eu",
          },
        },
      },
      map: {
        title: "Our spots & hours",
        description: "See the map, today’s opening hours, and how to reach us at each location.",
      },
      locations: {
        openMap: "Open in Google Maps",
        lakeVienna: {
          name: "Lake Vienna",
          address: "Near City Beach, Vienna",
        },
        danubeRiverside: {
          name: "Danube Riverside",
          address: "Riverside Spot, Vienna",
        },
        mountainLake: {
          name: "Mountain Lake",
          address: "Alpine Lake Resort",
        },
      },
      tips: {
        title: "Good to know before you arrive",
        description: "Quick reminders that keep your session relaxed and simple.",
        items: [
          "All rentals include paddles, life vests, and waterproof storage.",
          "Arrive 15 minutes early for a safety briefing and gear fitting.",
          "Basic swimming ability is required — we’ll tailor routes to your comfort.",
          "Kids under 12 paddle tandem with a parent or guardian.",
          "Wetsuits and glow-night add-ons available on request.",
        ],
      },
      faq: {
        title: "Your questions, answered",
        description: "Tap a topic to get the details before you roll up to the dock.",
        groups: [
          {
            title: "Planning & booking",
            description: "Prep the essentials before you arrive.",
          },
          {
            title: "Gear & logistics",
            description: "Know what’s included and how to gear up.",
          },
          {
            title: "Safety & policies",
            description: "Stay informed about requirements and rules.",
          },
          {
            title: "On-the-water experience",
            description: "What to expect once you’re out on the water.",
          },
          {
            title: "Extras & add-ons",
            description: "Bring the crew, pack extras, and make every ride feel custom.",
          },
          {
            title: "Night & weather",
            description: "Glow rides, weather pivots, and what to do if you take a dip.",
          },
        ],
        items: [
          {
            question: "Do I need prior SUP or kayak experience?",
            answer:
              "Nope! Our crew gives every guest a quick land-based briefing and stays available by phone while you paddle. We tailor recommendations to your comfort level.",
          },
          {
            question: "What should I bring to my session?",
            answer:
              "Pack swimwear or quick-dry clothes, a towel, sunscreen, and water. We provide boards, vests, dry bags, and extras like wetsuits or headlamps on request.",
          },
          {
            question: "Can I reschedule if the weather changes?",
            answer:
              "If winds go above safe limits or storms roll in, we’ll reach out proactively to shift your booking. You can also reschedule once for free with 24-hours notice.",
          },
          {
            question: "Is there a place to store personal items?",
            answer:
              "Yes, each launch base has secure storage for small bags and valuables. We also provide dry bags if you prefer to bring essentials along on the board.",
          },
          {
            question: "Can I rent without experience?",
            answer:
              "No experience needed! We give a quick intro on balance, paddling, and safety before you launch.",
          },
          {
            question: "Is it safe for kids?",
            answer: "Yes. Kids under 14 ride with an adult. We have life vests in multiple sizes.",
          },
          {
            question: "What should I bring?",
            answer:
              "Sunscreen, water, towel, and swim-ready clothes. Barefoot or water shoes work best.",
          },
          {
            question: "Do I need to know how to swim?",
            answer:
              "Basic swimming ability is required for safety. Life vests are provided and required.",
          },
          {
            question: "What if it rains or gets windy?",
            answer:
              "Safety first! We’ll reschedule for free if conditions aren’t safe (strong wind, storms).",
          },
          {
            question: "What’s your cancellation policy?",
            answer:
              "Free cancellation up to 24 hours before your start time. Inside 24h, contact us and we’ll try to help.",
          },
          {
            question: "Can I bring my dog?",
            answer:
              "Absolutely! Well-behaved pups are welcome. Dog life vests available in limited sizes.",
          },
          {
            question: "How early should I arrive?",
            answer: "Please arrive 10 minutes early for check-in, vest fitting, and the mini lesson.",
          },
          {
            question: "What’s included in the price?",
            answer:
              "Board or kayak, paddle, life vest, and a short on-shore intro. Add-ons like dry bags are optional.",
          },
          {
            question: "How long can I rent?",
            answer:
              "Choose 1h, 2h, or a day pass. Sunset and sunrise slots are available on request.",
          },
          {
            question: "Is there a weight limit?",
            answer:
              "Most boards support up to ~120 kg (265 lb). We have higher-capacity options—ask us when booking.",
          },
          {
            question: "Where do we paddle?",
            answer:
              "Launch from our dock and follow our suggested routes, or freestyle within the marked area.",
          },
          {
            question: "Do you provide storage for valuables?",
            answer:
              "We can hold small items (keys/phone) or rent you a waterproof bag for on-board storage.",
          },
          {
            question: "Is parking available?",
            answer:
              "Yes—parking is available near the launch. Details are in your booking confirmation.",
          },
          {
            question: "Can I book for a group or event?",
            answer:
              "Totally! We handle groups, birthdays, and team events. Message us for bundle options.",
          },
          {
            question: "Can I take photos on the water?",
            answer: "For sure! We recommend a waterproof case. We also rent phone pouches.",
          },
          {
            question: "What if I fall in?",
            answer:
              "No biggie—climb back on from the side, kneel to stabilize, then stand when ready.",
          },
          {
            question: "Do you accept card payments?",
            answer:
              "Yes—online card payments are preferred. On-site options vary; check your confirmation.",
          },
          {
            question: "Do I need an ID?",
            answer: "Please bring a valid photo ID for check-in and security purposes.",
          },
          {
            question: "What happens if I’m late returning?",
            answer:
              "A small overtime fee may apply. Call us if you’re delayed so we can assist.",
          },
          {
            question: "Any rules about alcohol?",
            answer:
              "For safety, no alcohol before or during your session. Save the toast for after 🥤.",
          },
          {
            question: "What should I wear?",
            answer:
              "Quick-dry sportswear or swimwear. Bring a spare layer if it’s breezy.",
          },
        ],
      },
    },
    policies: {
      title: "Policies & Safety",
      subtitle:
        "Understand how we protect your data, run safe sessions, and keep refunds fair — all in one quick read before you launch.",
      hero: {
        eyebrow: "Wayli policy hub",
        contact: "Need a custom contract or data export? Email wayli@wayli.eu.",
        points: {
          privacy: {
            title: "Data stays encrypted",
            description: "EU-based storage with tight access control and no ad sharing.",
          },
          terms: {
            title: "Transparent sessions",
            description: "Know the launch rules, safety expectations, and cancellation windows.",
          },
          refund: {
            title: "Flexible rebooking",
            description: "Weather pivots? Move your slot or request a refund — no fuss.",
          },
        },
      },
      nav: {
        label: "Legal quick navigation",
        heading: "Quick navigation",
      },
      sections: {
        privacy: {
          title: "Privacy Policy",
          eyebrow: "Your data, handled with care",
          p1:
            "We collect only the details needed to confirm bookings, tailor on-water experiences, and keep you in the loop about weather pivots or launch updates.",
          p2:
            "Core details include your name, contact info, preferred launch time, payment confirmations, and optional rider notes. Paddle metrics, GPS routes, or biometric data are never tracked.",
          p3:
            "You can request, export, or delete your stored information anytime by emailing wayli@wayli.eu. We respond within five business days — faster during the season.",
          b1: "We store booking data in encrypted, EU-based servers with limited access.",
          b2:
            "Cookies and similar storage support language choice, sign-in, booking recovery, maps, and consent-based analytics settings.",
          b3: "No guest data is sold or shared with advertisers — ever.",
        },
        terms: {
          title: "Terms & Conditions",
          eyebrow: "How we keep sessions smooth",
          p1:
            "By booking with Wayli you confirm you can swim, agree to wear a life vest, and follow staff instructions at launch or during guided outings.",
          p2:
            "Arrive 10 minutes early to review the route map, check wind conditions, and sign the digital waiver. Late arrivals may reduce paddle time so the next launch stays on schedule.",
          p3:
            "If the forecast shows unsafe winds or storms, we’ll pause departures and rebook you at no extra cost. Alcohol or substance use before or during a session isn’t allowed.",
          b1: "Gear must be returned rinsed and damage-free; repairs are billed at cost.",
          b2: "Group bookings require a 25% deposit that becomes non-refundable 48h before launch.",
          b3: "Guided tours may adjust routes on the water to maintain safety margins.",
        },
        refund: {
          title: "Refund Policy",
          eyebrow: "Fair and flexible",
          p1:
            "Plans change — we get it. Cancel 24 hours before your slot for a full refund, or roll your booking into a future date (valid for one season).",
          p2:
            "Inside 24 hours we’ll issue a 50% credit toward your next paddle. Same-day cancelations are non-refundable unless weather makes launching unsafe.",
          p3:
            "Refunds typically post within 3–5 business days depending on your payment provider. Reach us at wayli@wayli.eu if anything takes longer.",
          b1: "Gift vouchers are transferable once and retain the original expiry date.",
          b2: "Weather postponements can be rebooked or refunded in full — your choice.",
          b3: "No-shows are charged the full fee so we can keep gear staffed and ready.",
        },
      },
    },
    profilePage: {
      hero: {
        eyebrow: "Welcome back",
        fallbackName: "Friend",
        actions: {
          book: "Book a ride",
          edit: "Edit profile",
        },
        metrics: {
          upcoming: "Upcoming paddles",
          completed: "Completed rides",
          loyalty: "Loyalty progress",
        },
        loyalty: {
          title: "Glow Club progress",
          description: "{completed} of {goal} paddles completed — {remaining} more until your €20 discount!",
          ready: "You’ve completed all {goal} paddles — redeem your €20 discount!",
          frozen: "Reward voucher ready — use it to start collecting stamps again.",
          redeem: "Redeem reward",
          voucherTitle: "Voucher unlocked!",
          voucherHint: "Use this code at checkout for a €20 discount.",
        },
      },
      form: {
        fields: {
          name: "Full name",
          email: "Email",
        },
        actions: {
          cancel: "Cancel",
          save: "Save changes",
        },
      },
      edit: {
        title: "Edit profile details",
        lead:
          "Keep your contact details current so we can reach you about your adventures.",
        fields: {
          name: "Name",
          phone: "Phone number",
          phonePlaceholder: "Phone number",
          countryCode: "Country code",
        },
        saveLoading: "Saving...",
        save: "Save profile",
        validation: {
          nameRequired: "Name is required.",
          nameLength: "Name must be 30 characters or fewer.",
          phone: "Phone number must be in international format (e.g., +43123456789).",
        },
      },
      status: {
        updated: "Profile updated successfully.",
        updateError: "Could not save profile changes.",
      },
      password: {
        title: "Change password",
        lead: "Secure your account by updating your password below.",
        show: "Show password",
        hide: "Hide password",
        fields: {
          current: "Current password",
          new: "New password",
          confirm: "Confirm new password",
        },
        validation: {
          required: "Fill out every field before saving.",
          length: "Use at least 9 characters for your new password.",
          complexity: "Include an uppercase letter, a number, and a special character.",
          match: "New password and confirmation must match.",
          different: "New password must differ from the current one.",
          auth: "You need to log in again.",
        },
        save: "Update password",
        saveLoading: "Updating...",
        hint: "Use at least 9 characters, including an uppercase letter, a number, and a special character.",
        status: {
          updated: "Password updated successfully.",
          error: "Could not update your password.",
        },
      },
      sections: {
        account: {
          title: "Account details",
          edit: "Edit",
        },
        upcoming: {
          title: "Upcoming bookings",
          seeCalendar: "See calendar",
          reschedule: "Reschedule",
          cancel: "Cancel",
          empty: "No bookings yet. Time to plan the next paddle!",
          loading: "Fetching your bookings...",
          error: "We couldn’t load your bookings. Please try again shortly.",
          authRequired: "Please log in again to manage bookings.",
          nightLabel: "Night booking",
          dayLabel: "Day booking",
          qr: "Show QR",
          qrFallback: "Booking",
          qrTitle: "Pickup & return QR",
          qrLead:
            "Show this QR at pickup and return so staff can check out or check in your gear.",
          qrLoading: "Generating your QR...",
          qrAlt: "Booking QR",
          qrExpires: "Valid until",
          qrError: "Unable to generate a QR code.",
          rescheduleInvalid: "Pick a valid date and time.",
          rescheduleUnavailable:
            "That slot isn’t available for your selected gear. Please pick another time.",
          rescheduleError:
            "We couldn’t reschedule this booking. Please try another slot.",
          availabilityError: "We couldn’t verify availability. Please try again.",
          availabilityChecking: "Checking availability…",
          availabilityAvailable: "Great news! Your selected gear is available.",
          availabilityUnavailable: "Some gear is unavailable. Try another slot.",
          rescheduleTitle: "Reschedule booking",
          rescheduleLead: "Pick a new slot for {type} at {location}.",
          saveReschedule: "Save changes",
          cancelTitle: "Cancel booking",
          cancelLead: "Cancel {type} on {date} at {time}?",
          cancelLoading: "Cancelling…",
          confirmCancel: "Cancel booking",
          cancelNote: "Heads up: cancellations inside 24 hours may incur a fee.",
          cancelError: "We couldn’t cancel this booking right now. Please try again.",
          calendar: {
            title: "Bookings calendar",
            prevMonth: "Previous month",
            nextMonth: "Next month",
            hint: "Pick a date to review, reschedule, or cancel your booking.",
            empty: "No bookings on this day.",
            pickDay: "Choose a date to see what’s scheduled.",
            prompt: "Pick a day",
            days: {
              mon: "Mon",
              tue: "Tue",
              wed: "Wed",
              thu: "Thu",
              fri: "Fri",
              sat: "Sat",
              sun: "Sun",
            },
          },
        },
        past: {
          title: "Past rentals",
          bookAgain: "Book again",
          empty: "Your completed rides will appear here.",
        },
        payments: {
          title: "Payment methods",
          add: "Add new",
          remove: "Remove",
          expiry: "Exp {expiry}",
          empty: "No saved payment methods.",
          addTitle: "Add payment method",
          addLead: "Add a card so checkout stays fast and seamless.",
          addConfirm: "Add card",
          validationNumber: "Enter a valid card number (12-19 digits).",
          validationExpiry: "Enter expiry in MM/YY format.",
          validationCvv: "Enter a valid CVV (3-4 digits).",
          fields: {
            cardNumber: "Card number",
            expiry: "Expiry (MM/YY)",
            cvv: "CVV",
          },
          placeholders: {
            cardNumber: "1234 5678 9012 3456",
          },
        },
        invoices: {
          title: "Invoices",
          empty: "No invoices yet. Once you paddle, they’ll appear here.",
        },
        receipts: {
          title: "Receipts",
          refresh: "Refresh",
          loading: "Fetching your receipts...",
          error: "We couldn’t load your receipts. Please try again shortly.",
          downloadFailed: "Failed to download receipt.",
          downloading: "Downloading…",
          download: "Download",
          unknownLocation: "Receipt",
          bookingId: "Booking",
          empty:
            "No receipts yet. After your booking is paid, receipts will appear here.",
        },
      },
      motivation: {
        title: "Motivation station",
        subtitle: "Pick a vibe, get the stoke for your next session.",
        categories: {
          sup: "SUP Vibes",
          kayak: "Kayak Flow",
          swim: "Swim Energy",
        },
        quotes: {
          sup: [
            {
              text: "The board doesn’t move unless you do — stand tall, breathe deep, glide forward.",
              author: "Wayli Crew",
            },
            {
              text: "Balance isn’t about standing still. It’s about flowing with every ripple.",
              author: "Unknown Paddler",
            },
            {
              text: "Sunrise strokes, sunset smiles — SUP keeps your day anchored in joy.",
              author: "SUP Adventurer",
            },
          ],
          kayak: [
            {
              text: "Let the current teach you — steer with purpose, paddle with heart.",
              author: "River Guide",
            },
            {
              text: "Every stroke is a story written on water. Keep writing yours.",
              author: "Kayak Nomad",
            },
            {
              text: "Calm water or rolling waves, the kayak always answers to your courage.",
              author: "Wayli Crew",
            },
          ],
          swim: [
            {
              text: "The water meets you exactly where you are — dive in and be present.",
              author: "Open Water Swimmer",
            },
            {
              text: "Breathe, kick, reach, repeat. Progress is just rhythm in motion.",
              author: "Swim Coach",
            },
            {
              text: "Stronger with every lap, calmer with every glide.",
              author: "Wayli Crew",
            },
          ],
        },
      },
      quickActions: {
        title: "Quick actions",
        editProfile: "Edit profile",
        changePassword: "Change password",
        logout: "Log out",
      },
      actions: {
        cancel: "Never mind",
        keep: "Keep booking",
        closeDialog: "Close dialog",
      },
      loading: "Loading your profile...",
      error: {
        loadFailed: "Could not load your profile. Please log in again.",
        missing: "We couldn't retrieve your profile data.",
        loginAgain: "Back to login",
      },
    },
    bookingClosed: {
      eyebrow: "Wayli status",
      title: "We are currently closed",
      lead:
        "The water is calm, and we are taking a short break to reset. Your existing bookings stay valid, and we will reopen with fresh slots soon.",
      badges: {
        bookingsPaused: "Bookings paused",
        paymentsDisabled: "Payments disabled",
        temporarilyClosed: "Temporarily closed",
      },
    },
    googleMap: {
      consent: {
        eyebrow: "Functional content",
        title: "Map stays off until you allow it",
        description:
          "Wayli can show a live Google map after you enable functional cookies. You can still use the location list and open spots directly in Google Maps.",
        cta: "Enable Cookies",
        settings: "Cookie settings",
      },
      error: {
        unavailable:
          "Map unavailable. Check the Google Maps API key referrer restrictions.",
        missingKey: "Map API key is missing.",
      },
      loading: "Loading map...",
    },
  },
  de: {
    dateTimePicker: {
      title: "Datum & Uhrzeit wählen",
      durationHeading: "Dauer in Stunden:",
      durationDay: "Tag",
      actions: {
        cancel: "Abbrechen",
        save: "Speichern",
        saving: "Speichere…",
      },
    },
    auth: {
      language: {
        label: {
          en: "EN",
          de: "DE",
        },
        switchToGerman: "Auf Deutsch wechseln",
        switchToEnglish: "Auf Englisch wechseln",
      },
      fields: {
        email: "E-Mail",
        phone: "Telefon",
        phonePlaceholder: "Telefonnummer",
        password: "Passwort",
        confirmPassword: "Passwort bestätigen",
        countryCode: "Ländervorwahl",
      },
      password: {
        show: "Passwort anzeigen",
        hide: "Passwort verbergen",
      },
      loading: {
        checkingSession: "Deine Sitzung wird geprüft...",
        checkingAccess: "Zugriff wird geprüft...",
      },
      media: {
        loginAlt: "Person bereitet sich aufs Paddeln vor",
        registerAlt: "Freunde bereiten Paddle-Boards vor",
        resetAlt: "Wayli-Nutzer setzt das Passwort zurück",
      },
      register: {
        eyebrow: "Werde Teil der Crew",
        title: "Erstelle dein Wayli-Konto",
        lead:
          "Speichere deine Lieblingsspots, sammle Belohnungen und erhalte paddle-bereite Updates.",
        termsPrefix: "Ich stimme den",
        termsLink: "rechtlichen Richtlinien",
        termsSuffix: " zu.",
        primaryCta: "Registrieren",
        primaryCtaLoading: "Registrieren...",
        googleCta: "Mit Google registrieren",
        success: "Konto erstellt. Du kannst dich jetzt einloggen.",
        googleSuccess: "Mit Google angemeldet. Du wirst weitergeleitet...",
        error: {
          required: "Bitte gib E-Mail-Adresse, Telefonnummer und Passwort ein.",
          emailInvalid: "Bitte gib eine gültige E-Mail-Adresse ein.",
          emailTooLong: "Die E-Mail-Adresse darf maximal 128 Zeichen haben.",
          phoneInvalid:
            "Bitte gib eine gültige Telefonnummer im internationalen Format ein (z. B. +43123456789).",
          passwordInvalid:
            "Das Passwort muss mindestens 9 Zeichen lang sein und einen Großbuchstaben, eine Zahl und ein Sonderzeichen enthalten.",
          passwordTooLong: "Das Passwort darf maximal 64 Zeichen haben.",
          mismatch: "Die Passwörter stimmen nicht überein.",
          terms: "Bitte akzeptiere die rechtlichen Richtlinien.",
          generic: "Etwas ist schiefgelaufen. Bitte versuche es später erneut.",
          google:
            "Registrierung mit Google konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
        },
        footer: {
          text: "Du hast bereits ein Konto?",
          link: "Einloggen",
        },
      },
      login: {
        eyebrow: "Willkommen zurück",
        title: "Melde dich bei Wayli an",
        lead:
          "Setze deine nächste Paddle-Planung genau dort fort, wo du aufgehört hast.",
        rememberMe: "Angemeldet bleiben",
        forgotPassword: "Passwort vergessen?",
        primaryCta: "Einloggen",
        primaryCtaLoading: "Einloggen...",
        googleCta: "Weiter mit Google",
        success: "Willkommen zurück! Du wirst weitergeleitet...",
        postRegisterSuccess:
          "Konto erstellt. Melde dich mit deinen Zugangsdaten an.",
        error: {
          required: "Bitte gib E-Mail-Adresse und Passwort ein.",
          generic: "Ungültige Zugangsdaten. Bitte versuche es erneut.",
          google: "Anmeldung mit Google ist gerade nicht möglich.",
        },
        footer: {
          text: "Noch kein Konto?",
          link: "Jetzt erstellen",
        },
      },
      forgotPassword: {
        eyebrow: "Zugang zurücksetzen",
        title: "Setze dein Wayli-Passwort zurück",
        lead:
          "Gib die E-Mail-Adresse deines Kontos ein und wir senden dir einen Reset-Link.",
        successHeading: "Prüfe dein Postfach",
        successMessage:
          "Wir haben einen Link zum Zurücksetzen des Passworts an {email} geschickt. Der Link läuft in 30 Minuten ab, also nutze ihn bald.",
        successRetry: "Keine E-Mail erhalten? Prüfe den Spam-Ordner oder",
        successRetryCta: "nochmals senden",
        resendCta: "nochmals senden",
        resendCountdown: "erneut senden in {time}",
        resendSending: "Sende erneut...",
        resendCountdownMessage:
          "Du kannst den Reset-Link in {time} erneut senden.",
        changeEmailCta: "andere E-Mail verwenden",
        errorMessage: "Etwas ist schiefgelaufen. Bitte versuche es in Kürze erneut.",
        submit: {
          default: "Reset-Link senden",
          sending: "Sende...",
        },
        footer: {
          text: "Passwort wieder eingefallen?",
          link: "Zurück zum Login",
        },
      },
      resetPassword: {
        eyebrow: "Zugang zurücksetzen",
        title: "Neues Passwort festlegen",
        lead: "Erstelle ein neues Passwort für dein Wayli-Konto.",
        fields: {
          newPassword: "Neues Passwort",
          confirmPassword: "Passwort bestätigen",
        },
        submit: {
          default: "Passwort aktualisieren",
          saving: "Speichere...",
        },
        missingHeading: "Reset-Link fehlt oder ist ungültig",
        missingMessage: "Bitte fordere einen neuen Link zum Zurücksetzen an.",
        missingCta: "Neuen Link anfordern",
        missingToken: "Reset-Token fehlt.",
        missingPassword: "Bitte gib ein neues Passwort ein.",
        shortPassword: "Das Passwort muss mindestens 9 Zeichen lang sein.",
        weakPassword:
          "Das Passwort muss einen Großbuchstaben, eine Zahl und ein Sonderzeichen enthalten.",
        mismatch: "Die Passwörter stimmen nicht überein.",
        errorMessage: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
        successHeading: "Passwort aktualisiert",
        successMessage: "Du kannst dich jetzt mit deinem neuen Passwort anmelden.",
        successCta: "Zum Login",
        resendCta: "Neuen Reset-Link anfordern",
        footer: {
          text: "Passwort wieder eingefallen?",
          link: "Zurück zum Login",
        },
      },
    },
    header: {
      logoAlt: "Wayli-Logo",
      nav: {
        price: "PREIS",
        booking: "BUCHUNG",
        faq: "FAQ",
        info: "INFO",
      },
      actions: {
        switchToGerman: "Auf Deutsch wechseln",
        switchToEnglish: "Auf Englisch wechseln",
      },
      languageLabel: {
        en: "EN",
        de: "DE",
      },
    },
    footer: {
      heading: {
        line1: "Lasst uns",
        highlight: "gemeinsam",
        line2: "paddeln",
      },
      paragraph:
        "Wayli SUP- und Kajakverleih – wir machen Wasserabenteuer einfach, sicher und richtig lässig. Stabile Boards, frische Ausrüstung und ein Team, das das Wasser genauso liebt wie du. Ob deine erste Runde oder dein hundertster Paddeltrip: Wir haben Routen, Tipps und gute Laune für dich parat.",
      links: {
        privacy: "Datenschutz",
        cookies: "Cookie",
        terms: "Nutzungsbedingungen",
        refund: "Rückerstattungsrichtlinie",
      },
    },
    cookieBanner: {
      eyebrow: "Cookie-Einstellungen",
      title: "Wähle, wie Wayli Cookies verwendet",
      lead:
        "Wir verwenden notwendige Cookies, damit Login, Buchungswiederherstellung und grundlegende Einstellungen funktionieren. Wähle notwendig plus funktional für Karten oder alles, um zusätzlich die Web-Analyse zu aktivieren.",
      footnote: "Du kannst das jederzeit im Footer ändern.",
      actions: {
        reject: "Nur notwendige",
        acceptFunctional: "Notwendig + funktional",
        customize: "Einstellungen wählen",
        save: "Auswahl speichern",
        accept: "Alle",
        close: "Cookie-Einstellungen schließen",
      },
      categories: {
        necessary: {
          label: "Notwendig",
          summary: "Login, Buchungswiederherstellung, Sprache und deine Cookie-Auswahl.",
          title: "Immer aktiv",
          badge: "Erforderlich",
          description:
            "Wird für den Login-Status, die Wiederaufnahme von Buchungen nach Zahlungs-Weiterleitungen, die Spracheinstellung und das Speichern deiner Cookie-Auswahl benötigt.",
        },
        functional: {
          label: "Funktional",
          summary: "Google Maps und vergleichbare optionale Funktionen.",
          title: "Karten und Helfer",
          description:
            "Erlaubt Wayli, eingebettete Google Maps zu laden, wenn du die Kartenansicht nutzen möchtest.",
          toggle: "Funktionale Cookies umschalten",
        },
        analytics: {
          label: "Analyse",
          summary: "Messung von Besuchen für unsere eigenen Nutzungsberichte.",
          title: "Web-Analyse",
          description:
            "Erlaubt Wayli, Besuche mit einer lokalen Kennung und technischen Besuchsdaten zu messen, die an unseren Server gesendet werden.",
          toggle: "Analyse-Cookies umschalten",
        },
      },
    },
    bookingPage: {
      title: "Buche dein Abenteuer",
      prompt: "Jägst du heute die Sterne oder die Sonne?",
      day: {
        title: "Sonnenlicht-Jäger",
        description:
          "Treibe unter der Sonne über ruhiges Wasser und atme frische Luft.",
      },
      night: {
        title: "Mondschein-Gleiten",
        description:
          "Gleite unter den Sternen mit LED-SUP-Kits durch leuchtendes Wasser.",
      },
    },
    nightDayTrip: {
      defaultDayTitle: "Sonniger Paddeltrip",
      defaultDayDescription:
        "Genieße einen hellen und entspannten SUP- oder Kajakausflug unter blauem Himmel mit ruhigem Wasser und malerischen Ufern.",
      defaultNightTitle: "Nachtgleiten mit Glow",
      defaultNightDescription:
        "Erlebe das Paddeln unter den Sternen mit LED-Boards und friedlich schimmerndem Wasser.",
      button: "Jetzt buchen",
    },
    home: {
      hero: {
        headingLine1: "Erobere die Wellen.",
        headingLine2: "Dein Wasserabenteuer",
        headingLine3: "beginnt jetzt.",
        description:
          "Miete SUP-Boards, Kajaks und Ausrüstung in Minuten – ganz unkompliziert. Täglich verfügbar. Perfekt für Einsteiger und Profis.",
        cta: "Jetzt buchen",
        imageAlt: "Person auf einem SUP-Board",
      },
      price: {
        title: "Preise",
        note: "Alle Preise beinhalten Paddel, Weste & Tasche",
        cardCta: "Buchen",
        cards: {
          solo_glide: {
            title: "Solo Glide",
            price: "15 €/Stunde oder 55 €/Tag",
            items: [
              "Einzel-SUP",
              "1 Person",
              "Stabiles Allround-Board",
            ],
          },
          party_board: {
            title: "Party Board",
            price: "25 €/Stunde oder 70 €/Tag",
            items: [
              "Großes SUP",
              "Bis zu 6 Personen",
              "Ideal für Gruppen und Familien",
            ],
          },
          aqua_arrows: {
            title: "Aqua Arrows",
            price: "20 €/Stunde oder 65 €/Tag",
            items: [
              "Einzelkajak",
              "Einfach zu steuern",
            ],
          },
          extras_kit: {
            title: "Zusatzpaket",
            price: "5 € pro Ausfahrt",
            items: [
              "Handtuch",
              "Wasserdichte Handyhülle",
              "Sonnencreme",
            ],
          },
          glow_pack: {
            title: "Glow & Go Pack",
            price: "60 €/Nacht",
            items: [
              "Leuchtendes SUP",
              "Stirnlampe",
            ],
          },
          included: {
            title: "Inklusive",
            price: "Gratis",
            items: [
              "Wasserdichte Tasche",
              "Rettungswesten",
              "Paddel",
            ],
          },
        },
      },
      how: {
        title: "So funktioniert's",
        steps: [
          {
            title: "Wähle dein Board",
            text:
              "Such dir SUP oder Kajak aus, solo oder zu zweit, und ergänze Extras wie eine wasserdichte Tasche, eine Handyhülle oder eine Kinderweste.",
          },
          {
            title: "Stell die Uhr ein",
            text: "Wähle Datum, Startzeit und wie lange du aufs Wasser willst.",
          },
          {
            title: "Buchen & los!",
            text:
              "Buche online. Du erhältst sofort eine Bestätigung mit allen Details.",
          },
          {
            title: "Komm vorbei & zieh dich um",
            text:
              "Sei 10 Minuten vorher da, zeig deinen Ausweis, wir passen die Weste an und verstauen deine Sachen.",
          },
          {
            title: "Snack, Snap, Splash",
            text:
              "Mach Fotos, gönn dir Pausen und genieße das \"Hier bleib ich\"-Gefühl.",
          },
          {
            title: "Zurück cruisen & abklatschen",
            text:
              "Komm pünktlich zurück, wir kümmern uns um die Ausrüstung und du behältst das Grinsen. Wenn du magst, buchst du gleich die nächste Runde.",
          },
        ],
      },
      why: {
        title: "Warum mit uns paddeln?",
        tags: [
          "Freundliches Team aus Wassersport-Fans",
          "Keine Kaution nötig",
          "Saubere, sichere, gepflegte Ausrüstung",
          "Sicherheit zuerst",
          "Flexible Buchung – kostenlose Umbuchung",
          "Sonnenaufgang & Sonnenuntergang möglich",
          "Direkt am Wasser",
        ],
      },
      faq: {
        title: "Häufige Fragen",
        toggleLabel: "Häufige Fragen ein- oder ausklappen",
        items: [
          {
            question: "Kann ich ohne Erfahrung mieten?",
            answer:
              "Keine Erfahrung nötig! Wir erklären Balance, Paddeln und Sicherheit bevor du startest.",
          },
          {
            question: "Ist es für Kinder sicher?",
            answer:
              "Ja. Kinder unter 14 Jahren paddeln mit einem Erwachsenen. Wir haben Schwimmwesten in vielen Größen.",
          },
          {
            question: "Was soll ich mitbringen?",
            answer:
              "Sonnencreme, Wasser, Handtuch und badebereite Kleidung. Barfuß oder Wasserschuhe funktionieren am besten.",
          },
          {
            question: "Muss ich schwimmen können?",
            answer:
              "Grundlegende Schwimmkenntnisse sind aus Sicherheitsgründen erforderlich. Schwimmwesten sind inklusive und Pflicht.",
          },
          {
            question: "Was passiert, wenn es regnet oder windig wird?",
            answer:
              "Sicherheit zuerst! Wir verschieben kostenlos, wenn die Bedingungen nicht sicher sind (starker Wind, Sturm).",
          },
          {
            question: "Wie ist eure Stornopolitik?",
            answer:
              "Kostenlose Stornierung bis 24 Stunden vor Beginn. Danach melde dich bei uns und wir finden eine Lösung.",
          },
          {
            question: "Darf ich meinen Hund mitbringen?",
            answer:
              "Klar! Brave Hunde sind willkommen. Hundeschwimmwesten gibt es in begrenzten Größen.",
          },
          {
            question: "Wann soll ich ankommen?",
            answer:
              "Bitte sei 10 Minuten früher da für Check-in, Weste und eine kurze Einweisung.",
          },
          {
            question: "Was ist im Preis enthalten?",
            answer:
              "Board oder Kajak, Paddel, Schwimmweste und eine kurze Einweisung. Extras wie wasserdichte Taschen sind optional.",
          },
          {
            question: "Wie lange kann ich mieten?",
            answer:
              "Wähle 1 Stunde, 2 Stunden oder einen Tagespass. Zeitfenster zum Sonnenauf- und Sonnenuntergang sind auf Anfrage verfügbar.",
          },
          {
            question: "Gibt es ein Gewichtslimit?",
            answer:
              "Die meisten Boards tragen bis zu ca. 120 kg. Wir haben auch Boards mit höherer Tragkraft – frag uns einfach.",
          },
          {
            question: "Wo paddeln wir?",
            answer:
              "Starte bei unserem Steg, folge unseren Routentipps oder paddle frei innerhalb des markierten Bereichs.",
          },
          {
            question: "Habt ihr ein Depot für Wertsachen?",
            answer:
              "Wir bewahren kleine Dinge (Schlüssel/Handy) sicher auf oder verleihen wasserdichte Taschen.",
          },
          {
            question: "Gibt es Parkplätze?",
            answer:
              "Ja – Parkplätze gibt es in der Nähe. Details stehen in deiner Buchungsbestätigung.",
          },
          {
            question: "Kann ich für Gruppen buchen?",
            answer:
              "Auf jeden Fall! Wir organisieren Gruppen, Geburtstage und Firmenevents. Schreib uns für Angebote.",
          },
          {
            question: "Darf ich Fotos auf dem Wasser machen?",
            answer:
              "Natürlich! Wir empfehlen eine wasserdichte Hülle. Handybeutel kannst du bei uns leihen.",
          },
          {
            question: "Was passiert, wenn ich ins Wasser falle?",
            answer:
              "Kein Problem – steig seitlich wieder auf, knie dich zum Stabilisieren hin und steh erst auf, wenn du bereit bist.",
          },
          {
            question: "Nehmt ihr Kartenzahlung?",
            answer:
              "Ja – Online-Kartenzahlung ist bevorzugt. Vor Ort variiert es, schau in deiner Bestätigung nach.",
          },
          {
            question: "Brauche ich einen Ausweis?",
            answer:
              "Bitte bring einen gültigen Lichtbildausweis für den Check-in mit.",
          },
          {
            question: "Was wenn ich zu spät zurückkomme?",
            answer:
              "Eine kleine Überziehungsgebühr kann anfallen. Ruf uns an, wenn du dich verspätest.",
          },
          {
            question: "Gibt es Regeln zu Alkohol?",
            answer:
              "Zu deiner Sicherheit kein Alkohol vor oder während der Ausfahrt. Heb dir den Drink für danach auf 🥤.",
          },
          {
            question: "Was soll ich anziehen?",
            answer:
              "Schnelltrocknende Sport- oder Badebekleidung. Bring eine Lage mehr mit, falls es windig wird.",
          },
        ],
      },
    },
    bookingDay: {
      title: "Buche dein Abenteuer",
      eventCheckout: {
        title: "Jetzt buchen",
        heading: "Deine Eventübersicht",
        event: "Event",
        guests: "Gäste",
        capacity: "Kapazität",
        boards: "{count} SUP-Boards",
        bookedCount: "{booked} von {total} Plätzen gebucht",
        successTitle: "Eventzahlung erfolgreich!",
        successMessage:
          "Deine Eventzahlung ist abgeschlossen. Wir melden uns mit den Eventdetails.",
      },
      steps: {
        location: "Standort wählen",
        equipment: "Ausrüstung auswählen",
        dateTime: "Datum & Uhrzeit",
        confirmation: "Bestätigung",
      },
      controls: {
        previous: "Zurück",
        next: "Weiter",
        finish: "Fertig",
      },
      validation: {
        selectLocation: "Bitte wähle einen Standort, bevor du fortfährst.",
        selectEquipment: "Bitte wähle mindestens einen Ausrüstungsartikel.",
        blockedPickupReturn:
          "Abholung oder Rückgabe ist an einem der gewählten Tage nicht verfügbar.",
        selectDate: "Bitte wähle Datum und Uhrzeit, bevor du fortfährst.",
        selectEndDate: "Bitte wähle ein Enddatum, bevor du fortfährst.",
        outsideHours:
          "Bitte wähle einen gültigen Mietzeitraum innerhalb der verfügbaren Öffnungszeiten dieses Standorts.",
      },
      availability: {
        checking: "Verfügbarkeit wird geprüft…",
        available: "Gute Nachrichten! Deine gewählte Ausrüstung ist verfügbar.",
        error: "Die Verfügbarkeit konnte nicht geprüft werden. Bitte versuche es erneut.",
        unavailableShort:
          "Einige Ausrüstungsartikel sind nicht verfügbar. Wähle einen anderen Zeitraum oder passe die Menge an.",
        unavailableDates:
          "Die gewählte Ausrüstung ist am {dates} vollständig ausgebucht. Bitte wähle andere Tage oder reduziere die Menge.",
        unavailableInfoLabel: "Details zur nicht verfügbaren Ausrüstung anzeigen",
        unavailableListTitle: "Nicht verfügbar",
        need: "Benötigt",
        have: "Verfügbar",
        unavailableOn: "Ausgebucht am",
        unknownEquipment: "Ausrüstung",
      },
      equipment: {
        loading: "Ausrüstung wird geladen...",
        error: "Ausrüstung für diesen Standort konnte nicht geladen werden.",
        empty: "An diesem Standort ist gerade keine Ausrüstung verfügbar.",
        selectLocationPrompt:
          "Wähle zuerst einen Standort, um die verfügbare Ausrüstung zu sehen.",
      },
      locations: {
        loading: "Standorte werden geladen...",
        loadError: "Standorte können gerade nicht geladen werden.",
        empty: "Aktuell sind keine aktiven Standorte verfügbar.",
      },
      location: {
        description:
          "Wähle den Standort, der zu deiner Stimmung passt — sieh dir die Karte und die heutigen Zeiten an.",
        selectPrompt:
          "Tippe einen Standort an, um ihn auf der Karte zu sehen und die Zeiten einzublenden.",
        heading: "Standort auswählen",
        nightHeading: "Nacht-Standort auswählen",
        dotLabel: "Standortmarkierung",
      },
      items: {
        priceFallback: "Kostenlos",
        sup: {
          title: "Solo Glide",
          description: "Standard-SUP inkl. Paddel, Schwimmweste & Drybag",
        },
        big_sup: {
          title: "Party Board",
          description: "Großes SUP inkl. Paddel, Schwimmweste & Drybag",
        },
        kayak: {
          title: "Small Aqua Arrow",
          description: "Kajak inkl. Paddel, Schwimmweste & Drybag",
        },
        big_kayak: {
          title: "Big Aqua Arrow",
          description: "Großes Kajak inkl. Paddel, Schwimmweste & Drybag",
        },
        kit: {
          title: "Set",
          description: "Handtuch, wasserdichte Handyhülle und Taucherbrille",
        },
      },
      datetime: {
        cancel: "Abbrechen",
      },
      summary: {
        heading: "Deine Buchungsübersicht",
        location: "Standort",
        date: "Datum",
        time: "Zeit",
        start: "Start",
        end: "Ende",
        duration: "Dauer",
        durationHours: "{hours} Stunden",
        equipment: "Ausrüstung",
        noneSelected: "Keine Auswahl",
        equipmentFallback: "Keine Ausrüstung ausgewählt",
        durationDaysSingle: "1 Tag",
        durationDaysPlural: "{count} Tage",
        durationDaysDecimal: "{count} Tage",
        total: "Gesamtpreis",
        note:
          "Bitte überprüfe deine Angaben vor der Zahlung. Nach erfolgreicher Zahlung erhältst du eine Bestätigungs-E-Mail mit allen Details.",
        legalPrefix:
          "Mit dem Fortfahren zur Zahlung bestätigst du, dass du die",
        legalLink: "Rechtlichen Informationen",
        legalSuffix:
          "einschließlich der Allgemeinen Geschäftsbedingungen, Stornierungsbedingungen und Sicherheitsregeln gelesen hast und ihnen zustimmst; sie gelten für deine Buchung.",
        priceBanner: "Dein Mietpreis: €{price}",
      },
      voucher: {
        label: "Prämiengutschein",
        title: "Prämiengutschein",
        ready: "Freigeschaltet",
        locked: "Nach 5 Fahrten freischalten",
        placeholder: "Gutscheincode eingeben",
        apply: "Anwenden",
        appliedLabel: "Eingelöst",
        remove: "Entfernen",
        none: "Noch kein Prämiengutschein verfügbar. Nach 5 abgeschlossenen Fahrten freischalten.",
        enterCode: "Gib einen Prämiencode ein.",
        invalid: "Dieser Code ist kein gültiger Prämiengutschein.",
        applied: "Gutschein aktiviert! €20 Rabatt hinzugefügt.",
        promoApplied: "Promo-Code angewendet!",
        promoRedeemed: "Dieser Promo-Code wurde bereits eingelöst.",
        promoUnavailable: "Dieser Promo-Code ist nicht mehr verfügbar.",
        lost: "Gutschein nicht verfügbar. Bitte versuche einen anderen Code.",
        redeemed: "Dieser Gutschein wurde bereits eingelöst.",
        checkFailed: "Gutschein konnte nicht geprüft werden. Bitte versuche es erneut.",
        authRequired: "Bitte melde dich an, um den Gutschein einzulösen.",
        discountLine: "Gutschein angewendet: -€{amount}",
        originalTotal: "Vor Gutschein: €{amount}",
        discountLinePromo: "Promo-Code angewendet: -€{amount}",
        originalTotalPromo: "Vor Promo-Code: €{amount}",
      },
      payment: {
        missingIntent: "Stripe-Zahlungsabsicht fehlt.",
        intentMismatch:
          "Die Zahlungsabsicht stimmt nicht mit der ausstehenden Buchung überein.",
        stillProcessing:
          "Die Zahlung wird noch verarbeitet. Bitte prüfe es in einem Moment erneut.",
        notCompleted: "Die Zahlung wurde nicht abgeschlossen.",
        tabsLabel: "Zahlungsarten",
        apple: " Apple Pay",
        google: "Google Pay",
        revolut: "Revolut",
        cardLabel: "Kreditkarte",
        payWithApple: "Mit Apple Pay zahlen",
        payWithGoogle: "Mit Google Pay zahlen",
        payWithRevolut: "Mit Revolut zahlen",
        processing: "Wird verarbeitet…",
        checkingAvailability: "Einen Moment, wir prüfen die Verfügbarkeit.",
        configError: "Stripe-Zahlungen sind noch nicht konfiguriert.",
        confirm: "Buchung bestätigen",
        error: "Deine Buchung konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
        expired: "Diese Zahlungssitzung ist abgelaufen. Bitte starte eine neue Buchung.",
        incomplete:
          "Bitte wähle Standort, Zeit und Ausrüstung aus, bevor du zahlst.",
        reference: "Buchungsreferenz:",
        reset: "Zahlung zurücksetzen",
        retry: "Erneut versuchen",
        stuck: "Die Zahlung dauert länger als erwartet.",
        unsuccessful: "Die Zahlung konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
        contact: {
          invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
          title: "Wir brauchen noch deine Kontaktdaten",
          hint:
            "Gib E-Mail-Adresse und Telefonnummer ein, damit wir dir die Buchungsbestätigung senden können.",
          missing: "Bitte gib E-Mail-Adresse und Telefonnummer ein, um fortzufahren.",
          invalidPhone:
            "Bitte gib eine gültige Telefonnummer im internationalen Format ein (z. B. +43123456789).",
          countryCode: "Ländervorwahl",
          emailPlaceholder: "E-Mail-Adresse",
          phonePlaceholder: "Telefonnummer",
        },
        cardForm: {
          numberPlaceholder: "1234 5678 9012 3456",
          namePlaceholder: "Vorname Nachname",
          expPlaceholder: "MM/JJ",
          cvcPlaceholder: "CVV",
          incomplete: "Bitte vervollständige deine Kartendaten vor der Zahlung.",
          payButton: "Jetzt zahlen",
        },
        successTitle: "Zahlung erfolgreich!",
        successMessage:
          "Deine Buchung ist bestätigt. Eine Bestätigungs-E-Mail ist bereits unterwegs.",
        makeAnother: "Weitere Buchung vornehmen",
      },
      media: {
        confirmationAlt: "Buchungsbestätigung",
      },
      range: {
        title: "Wähle deinen Mietzeitraum",
        start: "Start",
        end: "Ende",
        startShort: "Start",
        endShort: "Ende",
        bridgePending: "Daten wählen",
        bridgeStart: "Enddatum wählen",
        bridgeHours: "{hours} Std.",
        bridgeDay: "{count} Tag",
        bridgeDays: "{count} Tage",
      },
      carousel: {
        prev: "Zurück",
        next: "Weiter",
      },
    },
    bookingNight: {
      title: "Mondschein-Paddelabenteuer",
      locationHeading: "Nacht-Standort auswählen",
      gearHeading: "Wähle deine Glow-Ausrüstung",
      controls: {
        previous: "Zurück",
        next: "Weiter",
        finish: "Fertig",
      },
      validation: {
        selectLocation: "Bitte wähle einen Standort, bevor du fortfährst.",
        selectEquipment: "Bitte wähle mindestens einen Ausrüstungsartikel.",
        selectDate: "Bitte wähle Datum und Uhrzeit, bevor du fortfährst.",
        pastTime: "Bitte wähle eine Startzeit in der Zukunft.",
        noSlotsToday:
          "Heute sind keine Zeitfenster mehr verfügbar. Bitte wähle ein anderes Datum.",
        outsideHours:
          "Diese Zeit liegt außerhalb der verfügbaren Öffnungszeiten für die gewählte Dauer.",
        endsNextDay: "Bitte wähle eine Zeit, die am selben Tag endet.",
      },
      availability: {
        checking: "Verfügbarkeit wird geprüft…",
        available: "Gute Nachrichten! Deine gewählte Ausrüstung ist verfügbar.",
        error: "Die Verfügbarkeit konnte nicht geprüft werden. Bitte versuche es erneut.",
        unavailableShort:
          "Einige Ausrüstungsartikel sind nicht verfügbar. Wähle einen anderen Zeitraum oder passe die Menge an.",
        unavailableInfoLabel: "Details zur nicht verfügbaren Ausrüstung anzeigen",
        unavailableListTitle: "Nicht verfügbar",
        need: "Benötigt",
        have: "Verfügbar",
        unknownEquipment: "Ausrüstung",
      },
      equipment: {
        loading: "Ausrüstung wird geladen...",
        error: "Ausrüstung für diesen Standort konnte nicht geladen werden.",
        empty: "An diesem Standort ist gerade keine Ausrüstung verfügbar.",
        selectLocationPrompt:
          "Wähle zuerst einen Standort, um die verfügbare Ausrüstung zu sehen.",
      },
      location: {
        description:
          "Wähle den Glow-Spot, der zu deiner Stimmung passt — sieh dir die Karte und die Abendzeiten an.",
        selectPrompt:
          "Tippe einen Standort an, um ihn auf der Karte zu sehen und die Abendzeiten zu prüfen.",
      },
      locations: {
        loading: "Standorte werden geladen...",
        loadError: "Standorte können gerade nicht geladen werden.",
        empty: "Aktuell sind keine aktiven Standorte verfügbar.",
        lake_vienna: "Wiener See",
        danube_riverside: "Donauufer",
        mountain_lake: "Bergsee",
      },
      items: {
        priceFallback: "Kostenlos",
        neon_board: {
          title: "Neon Glide Board",
          description: "LED-SUP, Paddel, Schwimmweste, Drybag",
        },
      },
      summary: {
        heading: "Deine Nachtbuchung",
        durationNight: "Nacht (flex)",
        note:
          "Überprüfe alle Angaben. Nach erfolgreicher Zahlung bekommst du eine E-Mail mit allen Infos für deine Nachtfahrt.",
        total: "Gesamtpreis",
        equipmentFallback: "Keine Ausrüstung ausgewählt",
      },
      aria: {
        add: "{item} hinzufügen",
        remove: "{item} entfernen",
      },
      payment: {
        successMessage:
          "Deine Nachtbuchung ist bestätigt. Viel Spaß unter den Sternen!",
        missingIntent: "Stripe-Zahlungsabsicht fehlt.",
        intentMismatch:
          "Die Zahlungsabsicht stimmt nicht mit der ausstehenden Buchung überein.",
        stillProcessing:
          "Die Zahlung wird noch verarbeitet. Bitte prüfe es in einem Moment erneut.",
        notCompleted: "Die Zahlung wurde nicht abgeschlossen.",
        processing: "Wird verarbeitet…",
        checkingAvailability: "Einen Moment, wir prüfen die Verfügbarkeit.",
        configError: "Stripe-Zahlungen sind noch nicht konfiguriert.",
        confirm: "Buchung bestätigen",
        error: "Deine Buchung konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
        expired: "Diese Zahlungssitzung ist abgelaufen. Bitte starte eine neue Buchung.",
        incomplete:
          "Bitte wähle Standort, Zeit und Ausrüstung aus, bevor du zahlst.",
        unavailable:
          "Dieses Zeitfenster ist nicht mehr verfügbar. Bitte wähle eine andere Zeit oder passe deine Ausrüstung an.",
        reset: "Zahlung zurücksetzen",
        retry: "Erneut versuchen",
        stuck: "Die Zahlung dauert länger als erwartet.",
        unsuccessful: "Die Zahlung konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
        cardForm: {
          payButton: "Jetzt zahlen",
        },
        contact: {
          invalidEmail: "Bitte gib eine gültige E-Mail-Adresse ein.",
          title: "Kontaktdaten hinzufügen",
          hint:
            "Wir senden die Bestätigung für die Glow-Tour an diese E-Mail-Adresse und Telefonnummer.",
          missing: "Bitte gib E-Mail-Adresse und Telefonnummer ein, um fortzufahren.",
          invalidPhone:
            "Bitte gib eine gültige Telefonnummer im internationalen Format ein (z. B. +43123456789).",
          countryCode: "Ländervorwahl",
          emailPlaceholder: "E-Mail-Adresse",
          phonePlaceholder: "Telefonnummer",
        },
      },
      media: {
        confirmationAlt: "Bestätigung der Nachtbuchung",
      },
    },
    bookingAction: {
      status: {
        reserved: "Reserviert",
        inUse: "In Benutzung",
        completed: "Abgeschlossen",
        cancelled: "Storniert",
        unknown: "Unbekannt",
      },
      actions: {
        checkout: "Ausgeben",
        returned: "Zurückgegeben",
      },
      hero: {
        eyebrow: "Wayli Partner-Scan",
        title: "Buchungs-QR-Aktion",
        subhead:
          "Diese Seite zeigt eine einzelne Buchung. Aktionen erfordern eine gültige Standort- oder Admin-PIN.",
      },
      loading: "Buchungsdetails werden geladen...",
      errorTitle: "Buchung konnte nicht geladen werden",
      errors: {
        missingToken: "Buchungstoken fehlt.",
        expired: "Dieser Buchungslink ist abgelaufen oder wurde widerrufen.",
        invalid: "Dieser Buchungslink ist ungültig.",
        loadFailed: "Diese Buchung konnte nicht geladen werden.",
        pinLength: "Gib eine 4- bis 6-stellige Zugangs-PIN ein.",
        tooManyAttempts:
          "Zu viele fehlgeschlagene Versuche. Bitte warte kurz und versuche es erneut.",
        pinFailed: "PIN-Prüfung fehlgeschlagen.",
      },
      success: {
        checkedOut: "Ausgegeben",
        checkedIn: "Zurückgenommen",
        suffix: "erfolgreich",
      },
      summary: {
        qrValidUntil: "QR gültig bis",
        equipment: "Ausrüstung",
        noEquipment: "Keine Ausrüstung aufgeführt.",
        time: "Zeit",
        pickupLocation: "Abholort",
        locationFallback: "Abholort",
        noActions: "Für diese Buchung sind derzeit keine Aktionen verfügbar.",
      },
      pin: {
        title: "Zugangs-PIN erforderlich",
        lead: "Gib die Standort-PIN oder die globale Admin-PIN ein, um diese Aktion zu bestätigen.",
        label: "Zugangs-PIN",
        cancel: "Abbrechen",
        checking: "Prüfe...",
        confirm: "Bestätigen",
      },
    },
    bookingShared: {
      validationMessage: "Bitte wähle mindestens einen Ausrüstungsartikel.",
    },
    info: {
      title: "SUP- & Kajak-Mietinfos",
      sections: {
        hours: {
          title: "Öffnungszeiten",
          days: {
            weekday: "Montag – Freitag",
            saturday: "Samstag",
            sunday: "Sonntag & Feiertage",
          },
          hours: {
            weekday: "08:00 – 20:00",
            saturday: "09:00 – 18:00",
            sunday: "Geschlossen",
          },
        },
        locations: {
          title: "Unsere Standorte",
        },
        contact: {
          title: "Kontakt",
          phone: "📞 Telefon",
          email: "📧 E-Mail",
          website: "🌍 Website",
          follow: "📲 Folge uns:",
        },
        infoList: {
          title: "Gut zu wissen",
          items: [
            "Alle Mieten beinhalten Paddel, Schwimmweste und Drybag.",
            "Bitte 15 Minuten vor deiner Buchung ankommen.",
            "Grundlegende Schwimmkenntnisse sind erforderlich.",
            "Kinder unter 12 Jahren nur in Begleitung eines Erwachsenen.",
            "Neoprenanzüge auf Anfrage gegen Aufpreis erhältlich.",
          ],
        },
      },
    },
    infoPage: {
      hero: {
        eyebrow: "Plane dein Paddelabenteuer",
        heading: "Alles, was du vor dem Start wissen musst",
        description:
          "Öffnungszeiten, Einstiegsstellen, Packliste und Kontaktinformationen. Klär alle Details, dann geht’s entspannt aufs Wasser.",
        primaryCta: "Ausfahrt buchen",
        secondaryCta: "Häufige Fragen ansehen",
        imageAlt: "Das Wayli-Team bereitet SUP-Boards am Wasser vor",
      },
      highlights: [
        {
          title: "Flexible Startzeiten",
          description: "Morgens, nachmittags oder zum Sonnenuntergang – jeden Tag einsatzbereit.",
        },
        {
          title: "Boards & Kajaks top gepflegt",
          description: "Frisch gespülte Ausrüstung, Glow-Kits für die Nacht und optionale Extras.",
        },
        {
          title: "Lieferung auf Anfrage",
          description:
            "Eine Lieferung an deine Adresse kann nach Absprache per E-Mail oder WhatsApp für 5 € organisiert werden.",
        },
      ],
      events: {
        eyebrow: "Events",
        title: "Kommende Wassersessions",
        book: "Jetzt buchen",
        controls: "Events scrollen",
        previous: "Vorherige Events",
        next: "Nächste Events",
        loading: "Events werden geladen...",
        loadError: "Events können gerade nicht geladen werden.",
        fallbackTitle: "Event",
        pickup: "Abholung",
        return: "Rückgabe",
        scheduleCount: "{count} Termine",
        modal: {
          eventDetails: "Eventdetails",
          time: "Zeit",
          location: "Ort",
          openMaps: "In Google Maps öffnen",
          duration: "Dauer",
          eventDate: "Eventdatum",
          availability: "Verfügbarkeit",
          bookedCount: "{booked} von {total} Plätzen gebucht",
          left: "frei",
          total: "Gesamt",
          included: "Inklusive",
          equipment: "Ausrüstung",
          chooseEquipment: "Wähle, was du brauchst",
          totalSelected: "{count} ausgewählt",
          boards: "Boards",
          boardQuantity: "Board-Anzahl",
          boardsLeft: "{count} verfügbar",
          supBoards: "SUP-Boards",
          pickupReturn: "Abholung und Rückgabe wählen",
          pickupReturnHint: "Wähle, wann du dein Board abholst und wann du es zurückbringst.",
          pickup: "Abholung",
          return: "Rückgabe",
          noBookableDates:
            "Für dieses Event sind keine buchbaren Termine konfiguriert.",
          invalidPickupReturn: "Die Rückgabezeit muss nach der Abholzeit liegen und beide Zeiten müssen im Event-Zeitfenster sein.",
          request: "Buchung anfragen",
        },
        items: {
          sunset: {
            title: "Sunset Paddle Social",
            description:
              "Eine entspannte Gruppenrunde zur Golden Hour mit ruhigem Tempo, Fotostopps und einfacher Route.",
            detail:
              "Ideal für kleine Gruppen, Einsteiger und alle, die einen entspannten Abend auf dem Wasser wollen.",
            location: "Donauufer",
            duration: "2 Stunden",
            capacity: "Bis zu 10 Gäste",
            price: "Ab 24 EUR",
            included: [
              "SUP- oder Kajak-Setup, Paddel, Schwimmweste und Drybag.",
              "Kurzes Sicherheitsbriefing und Routenvorschlag.",
              "Fotopause am ruhigsten Punkt der Route.",
            ],
          },
          family: {
            title: "Family Morning Paddle",
            description:
              "Ein ruhiger Morgentermin für Familien und Gruppen mit gemischter Erfahrung, klarer Zeitplanung und stabilem Equipment.",
            detail:
              "Wir halten die Route einfach, passen Westen vor dem Start an und helfen bei der passenden Board- oder Kajak-Auswahl.",
            location: "Wiener See",
            duration: "90 Minuten",
            capacity: "Bis zu 8 Gäste",
            price: "Ab 18 EUR",
            included: [
              "Stabile Boards oder Kajaks passend zu eurer Gruppe.",
              "Kinderwesten, falls benötigt.",
              "Einfacher Ablauf für Abholung und Rückgabe am Startpunkt.",
            ],
          },
          glow: {
            title: "Glow Night Session",
            description:
              "Eine limitierte Abendsession mit Glow-Gear, dunklerem Wasser und atmosphärischer Gruppenroute.",
            detail:
              "Für sichere Schwimmer gedacht, die eine besondere Nachtfahrt in kleiner betreuter Gruppe wollen.",
            location: "Donauufer",
            duration: "2 Stunden",
            capacity: "Bis zu 6 Gäste",
            price: "Ab 34 EUR",
            included: [
              "LED-SUP-Setup, Paddel, Weste und Drybag.",
              "Nacht-spezifisches Sicherheitsbriefing vor dem Start.",
              "Kleine Gruppe für eine ruhigere Route.",
            ],
          },
          coffee: {
            title: "Coffee Cruise",
            description:
              "Eine einfache Paddelrunde am späten Vormittag mit ruhiger Route und Zeit zum Durchatmen.",
            detail:
              "Eine entspannte Session für Gäste, die klare Anleitung, lockeres Timing und eine kurze Route möchten.",
            location: "Wiener See",
            duration: "75 Minuten",
            capacity: "Bis zu 7 Gäste",
            price: "Ab 16 EUR",
            included: [
              "Stabiles SUP-Setup mit Paddel, Weste und Drybag.",
              "Einsteigerfreundliches Tempo und Routenbriefing.",
              "Optionaler Café-Tipp nach der Rückgabe.",
            ],
          },
          team: {
            title: "Team Paddle Hour",
            description:
              "Ein kompaktes Teamformat für Kolleginnen, Kollegen oder Freunde mit einfacher Abstimmung.",
            detail:
              "Für Teams, die eine soziale Aktivität ohne komplizierte Route, Kaution oder langes Briefing wollen.",
            location: "Donauufer",
            duration: "90 Minuten",
            capacity: "Bis zu 12 Gäste",
            price: "Ab 22 EUR",
            included: [
              "Gemischtes SUP- und Kajak-Setup je nach Gruppengröße.",
              "Gemeinsamer Routenplan und klare Rückgabezeit.",
              "Unterstützung beim Gruppen-Check-in am Startpunkt.",
            ],
          },
          skills: {
            title: "Balance Skills Clinic",
            description:
              "Eine fokussierte SUP-Session für Stand, Turns, Wiederaufstieg und mehr Sicherheit nahe am Ufer.",
            detail:
              "Gut für wiederkehrende Paddler, die vor längeren selbstgeführten Routen mehr Kontrolle wollen.",
            location: "Wiener See",
            duration: "90 Minuten",
            capacity: "Bis zu 6 Gäste",
            price: "Ab 28 EUR",
            included: [
              "SUP-Board, Paddel, Weste und Drybag.",
              "Technikfokussiertes Briefing vor dem Start.",
              "Kleine Gruppe für mehr individuelles Feedback.",
            ],
          },
          discovery: {
            title: "Kayak Discovery",
            description:
              "Eine kurze geführte Kajakroute für Gäste, die stabile Sitzposition und einfache Paddeltechnik bevorzugen.",
            detail:
              "Ideal für Gäste, die lieber im Kajak sitzen als auf dem SUP stehen, mit Route nahe am Ufer.",
            location: "Wiener See",
            duration: "2 Stunden",
            capacity: "Bis zu 9 Gäste",
            price: "Ab 25 EUR",
            included: [
              "Einzel- oder Doppelkajak, Paddel, Weste und Drybag.",
              "Grundlagen zu Steuerung und Route.",
              "Ruhige Route passend zum Tag.",
            ],
          },
          afterWork: {
            title: "After Work Reset",
            description:
              "Eine klare einstündige Pause nach der Arbeit mit schnellem Check-in, fertigem Equipment und einfacher Rückgabe.",
            detail:
              "Für alle, die kurz aufs Wasser wollen, ohne direkt eine ganze Abendsession zu planen.",
            location: "Donauufer",
            duration: "60 Minuten",
            capacity: "Bis zu 10 Gäste",
            price: "Ab 14 EUR",
            included: [
              "Schnelle Ausgabe mit SUP- oder Kajak-Setup.",
              "Kompakte Routenempfehlung.",
              "Rückgabeunterstützung vor Schließzeit.",
            ],
          },
        },
      },
      hours: {
        title: "Öffnungszeiten",
        description: "Zeitslots abgestimmt auf ruhiges Wasser und goldenes Licht.",
        rows: {
          weekday: {
            label: "Montag – Freitag",
            value: "08:00 – 20:00",
          },
          saturday: {
            label: "Samstag",
            value: "09:00 – 18:00",
          },
          sunday: {
            label: "Sonntag & Feiertage",
            value: "Geschlossen (Gruppen auf Anfrage)",
          },
        },
      },
      contact: {
        title: "Bleib in Kontakt",
        description:
          "Buchung anpassen, Extras hinzufügen oder Fragen stellen? Wir sind nur eine Nachricht entfernt.",
        items: {
          phone: {
            label: "Ruf uns an",
            value: "+43 123 456 789",
          },
          email: {
            label: "Schreib uns",
            value: "wayli@wayli.eu",
          },
          whatsapp: {
            label: "Schreib uns auf WhatsApp",
            value: "wayli whatsapp",
          },
          instagram: {
            label: "Folge uns auf Instagram",
            value: "@wayli.eu",
          },
          tiktok: {
            label: "Werde Teil der Community",
            value: "tiktok.com/@wayli.eu",
          },
        },
      },
      map: {
        title: "Spots & Öffnungszeiten",
        description: "Sieh dir die Karte an, die heutigen Öffnungszeiten und wie du uns erreichst.",
      },
      locations: {
        openMap: "In Google Maps öffnen",
        loading: "Standorte werden geladen...",
        loadError: "Standorte können gerade nicht geladen werden.",
        empty: "Aktuell sind keine aktiven Einstiegsstellen verfügbar.",
        scheduleLabel: "Öffnungszeiten",
        scheduleMissing: "Öffnungszeiten nicht verfügbar.",
        lakeVienna: {
          name: "Wiener See",
          address: "Nähe City Beach, Wien",
        },
        danubeRiverside: {
          name: "Donauufer",
          address: "Donauufer-Spot, Wien",
        },
        mountainLake: {
          name: "Bergsee",
          address: "Alpines See-Resort",
        },
      },
      tips: {
        title: "Gut zu wissen vor deiner Ankunft",
        description: "Kurze Hinweise, damit dein Ausflug entspannt und unkompliziert bleibt.",
        items: [
          "Alle Mieten beinhalten Paddel, Schwimmweste und Drybag.",
          "Komm 15 Minuten früher für Sicherheitseinweisung und Anpassung der Ausrüstung.",
          "Grundlegende Schwimmkenntnisse sind Pflicht – wir passen Routen an dein Level an.",
          "Kinder unter 12 paddeln im Tandem mit einer Begleitperson.",
          "Neoprenanzüge und Extras für Nachtfahrten sind auf Anfrage verfügbar.",
        ],
      },
      faq: {
        title: "Deine Fragen, unsere Antworten",
        description: "Tippe auf ein Thema und klär alles, bevor du zum Steg rollst.",
        groups: [
          {
            title: "Planung & Buchung",
            description: "Bereite alles vor, bevor du ankommst.",
          },
          {
            title: "Ausrüstung & Logistik",
            description: "Weiß, was inkludiert ist und wie du dich ausstattest.",
          },
          {
            title: "Sicherheit & Richtlinien",
            description: "Alle Anforderungen und Regeln im Blick behalten.",
          },
          {
            title: "Erlebnis auf dem Wasser",
            description: "So fühlt sich deine Zeit auf dem Wasser an.",
          },
          {
            title: "Extras & Add-ons",
            description: "Hund an Bord, Extras mitnehmen und die Gruppe für Events erweitern.",
          },
          {
            title: "Nacht & Wetter",
            description: "Glow-Touren, Wetterwechsel und was zu tun ist, wenn du baden gehst.",
          },
        ],
        items: [
          {
            question: "Brauche ich SUP- oder Kajak-Erfahrung?",
            answer:
              "Nein. Wir geben dir vor dem Start ein kurzes Briefing an Land und sind während deiner Ausfahrt telefonisch erreichbar. Unsere Empfehlungen passen wir an dein Level an.",
          },
          {
            question: "Was soll ich zu meiner Ausfahrt mitbringen?",
            answer:
              "Pack Bade- oder schnelltrocknende Kleidung, Handtuch, Sonnencreme und Wasser ein. Boards, Westen, Drybags und Extras wie Neopren oder Stirnlampe bekommst du bei uns.",
          },
          {
            question: "Kann ich umbuchen, wenn sich das Wetter ändert?",
            answer:
              "Bei starkem Wind oder Gewitter melden wir uns proaktiv, um deine Buchung zu verschieben. Du kannst auch selbst einmal kostenlos bis 24 Stunden vorher umbuchen.",
          },
          {
            question: "Gibt es Stauraum für persönliche Dinge?",
            answer:
              "Ja, an jedem Spot gibt es sichere Aufbewahrung für kleine Taschen und Wertsachen. Auf Wunsch bekommst du einen Drybag für unterwegs.",
          },
          {
            question: "Kann ich ohne Erfahrung mieten?",
            answer:
              "Keine Erfahrung nötig! Wir erklären Balance, Paddeln und Sicherheit bevor du startest.",
          },
          {
            question: "Ist es für Kinder sicher?",
            answer:
              "Ja. Kinder unter 14 Jahren paddeln mit einem Erwachsenen. Wir haben Schwimmwesten in vielen Größen.",
          },
          {
            question: "Was soll ich mitbringen?",
            answer:
              "Sonnencreme, Wasser, Handtuch und badebereite Kleidung. Barfuß oder Wasserschuhe funktionieren am besten.",
          },
          {
            question: "Muss ich schwimmen können?",
            answer:
              "Grundlegende Schwimmkenntnisse sind aus Sicherheitsgründen erforderlich. Schwimmwesten sind inklusive und Pflicht.",
          },
          {
            question: "Was passiert, wenn es regnet oder windig wird?",
            answer:
              "Sicherheit zuerst! Wir verschieben kostenlos, wenn die Bedingungen nicht sicher sind (starker Wind, Sturm).",
          },
          {
            question: "Wie ist eure Stornopolitik?",
            answer:
              "Kostenlose Stornierung bis 24 Stunden vor Beginn. Danach melde dich bei uns und wir finden eine Lösung.",
          },
          {
            question: "Darf ich meinen Hund mitbringen?",
            answer:
              "Klar! Brave Hunde sind willkommen. Hundeschwimmwesten gibt es in begrenzten Größen.",
          },
          {
            question: "Wann soll ich ankommen?",
            answer:
              "Bitte sei 10 Minuten früher da für Check-in, Weste und eine kurze Einweisung.",
          },
          {
            question: "Was ist im Preis enthalten?",
            answer:
              "Board oder Kajak, Paddel, Schwimmweste und eine kurze Einweisung. Extras wie wasserdichte Taschen sind optional.",
          },
          {
            question: "Wie lange kann ich mieten?",
            answer:
              "Wähle 1 Stunde, 2 Stunden oder einen Tagespass. Zeitfenster zum Sonnenauf- und Sonnenuntergang sind auf Anfrage verfügbar.",
          },
          {
            question: "Gibt es ein Gewichtslimit?",
            answer:
              "Die meisten Boards tragen bis zu ca. 120 kg. Wir haben auch Boards mit höherer Tragkraft – frag uns einfach.",
          },
          {
            question: "Wo paddeln wir?",
            answer:
              "Starte bei unserem Steg, folge unseren Routentipps oder paddle frei innerhalb des markierten Bereichs.",
          },
          {
            question: "Habt ihr ein Depot für Wertsachen?",
            answer:
              "Wir bewahren kleine Dinge (Schlüssel/Handy) sicher auf oder verleihen wasserdichte Taschen.",
          },
          {
            question: "Gibt es Parkplätze?",
            answer:
              "Ja – Parkplätze gibt es in der Nähe. Details stehen in deiner Buchungsbestätigung.",
          },
          {
            question: "Kann ich für Gruppen buchen?",
            answer:
              "Auf jeden Fall! Wir organisieren Gruppen, Geburtstage und Firmenevents. Schreib uns für Angebote.",
          },
          {
            question: "Darf ich Fotos auf dem Wasser machen?",
            answer:
              "Natürlich! Wir empfehlen eine wasserdichte Hülle. Handybeutel kannst du bei uns leihen.",
          },
          {
            question: "Was passiert, wenn ich ins Wasser falle?",
            answer:
              "Kein Problem – steig seitlich wieder auf, knie dich zum Stabilisieren hin und steh erst auf, wenn du bereit bist.",
          },
          {
            question: "Nehmt ihr Kartenzahlung?",
            answer:
              "Ja – Online-Kartenzahlung ist bevorzugt. Vor Ort variiert es, schau in deiner Bestätigung nach.",
          },
          {
            question: "Brauche ich einen Ausweis?",
            answer:
              "Bitte bring einen gültigen Lichtbildausweis für den Check-in mit.",
          },
          {
            question: "Was passiert, wenn ich zu spät zurückkomme?",
            answer:
              "Eine kleine Überziehungsgebühr kann anfallen. Ruf uns an, wenn du dich verspätest.",
          },
          {
            question: "Gibt es Regeln zu Alkohol?",
            answer:
              "Zu deiner Sicherheit kein Alkohol vor oder während der Ausfahrt. Heb dir den Drink für danach auf 🥤.",
          },
          {
            question: "Was soll ich anziehen?",
            answer:
              "Schnelltrocknende Sport- oder Badebekleidung. Bring eine Lage mehr mit, falls es windig wird.",
          },
        ],
      },
    },
    login: {
      title: "Willkommen zurück!",
      email: "E-Mail",
      password: "Passwort",
      remember: "Angemeldet bleiben",
      forgot: "Passwort vergessen?",
      loginButton: "Einloggen",
      googleButton: "Mit Google anmelden",
      signupPrompt: "Noch kein Konto?",
      signupCta: "Jetzt registrieren!",
    },
    register: {
      title: "Schließe dich uns an!",
      email: "E-Mail",
      password: "Passwort",
      repeatPassword: "Passwort wiederholen",
      termsText: "Ich stimme den {terms} und dem {privacy} zu",
      termsLabel: "Nutzungsbedingungen",
      privacyLabel: "Datenschutz",
      signupButton: "Registrieren",
      googleButton: "Mit Google registrieren",
      signinPrompt: "Bereits ein Konto?",
      signinCta: "Jetzt einloggen!",
    },
    profile: {
      modal: {
        close: "Schließen",
      },
      progressTitle: "🎯 Dein Fortschritt",
      progressText:
        "3 von 5 Paddelrunden geschafft — noch 2 bis zu deinem 20-€-Rabatt! 🏆",
      upcomingTitle: "⏰ Bevorstehende Buchungen",
      pastTitle: "🕓 Vergangene Mieten",
      favoritesTitle: "⭐ Favoriten",
      paymentTitle: "💳 Zahlungsmethoden",
      invoicesTitle: "🧾 Rechnungen",
      noBookings: "Noch keine Buchungen.",
      noPayments: "Keine gespeicherten Zahlungsmittel.",
      noInvoices: "Noch keine Rechnungen.",
      actions: {
        edit: "Profil bearbeiten",
        password: "Passwort ändern",
        logout: "Abmelden",
        reschedule: "Umbuchen",
        cancel: "Stornieren",
        bookAgain: "Nochmal buchen",
      },
    },
    policies: {
      title: "Richtlinien & Sicherheit",
      subtitle:
        "Erfahre, wie wir deine Daten schützen, sichere Ausfahrten ermöglichen und faire Rückerstattungen handhaben – alles in einem kurzen Überblick vor deinem Start.",
      hero: {
        eyebrow: "Wayli Richtlinien-Hub",
        contact: "Individuellen Vertrag oder Datenauszug nötig? Schreib an wayli@wayli.eu.",
        points: {
          privacy: {
            title: "Daten bleiben verschlüsselt",
            description: "EU-Server mit strenger Zugriffskontrolle, keine Weitergabe an Werbepartner.",
          },
          terms: {
            title: "Klare Regeln",
            description: "Kenne Startregeln, Sicherheitserwartungen und Stornofristen.",
          },
          refund: {
            title: "Flexible Umbuchung",
            description: "Wetter kippt? Zeitfenster verschieben oder Rückerstattung anfordern – ganz entspannt.",
          },
        },
      },
      nav: {
        label: "Rechtliche Schnellnavigation",
        heading: "Schnellzugriff",
      },
      sections: {
        privacy: {
          title: "Datenschutzerklärung",
          eyebrow: "Deine Daten, sorgsam behandelt",
          p1:
            "Wir erfassen nur die Angaben, die wir zur Bestätigung deiner Buchung, zur Abstimmung deiner Ausfahrt und für Wetterhinweise oder Updates zu deinem Start benötigen.",
          p2:
            "Dazu gehören Name, Kontaktinfos, bevorzugte Startzeit, Zahlungsbestätigung und optionale Hinweise der Paddler. Paddeldaten, GPS-Routen oder biometrische Informationen speichern wir nie.",
          p3:
            "Du kannst deine gespeicherten Daten jederzeit anfordern, exportieren oder löschen lassen – einfach Mail an wayli@wayli.eu. Wir antworten innerhalb von fünf Werktagen, in der Saison schneller.",
          b1: "Wir speichern Buchungsdaten verschlüsselt auf EU-Servern mit begrenztem Zugriff.",
          b2:
            "Cookies und vergleichbare Speicherungen unterstützen Sprachauswahl, Login, Buchungswiederherstellung, Karten und einwilligungsbasierte Analyse-Einstellungen.",
          b3: "Keine Gästedaten werden jemals verkauft oder zu Werbezwecken weitergegeben.",
        },
        terms: {
          title: "Allgemeine Geschäftsbedingungen",
          eyebrow: "So bleiben Ausfahrten reibungslos",
          p1:
            "Mit deiner Buchung bestätigst du, dass du schwimmen kannst, eine Rettungsweste trägst und den Anweisungen des Teams am Start oder während geführter Touren folgst.",
          p2:
            "Sei 10 Minuten früher da, damit genug Zeit für Routenplan, Windcheck und den digitalen Haftungsausschluss bleibt. Verspätungen können deine Paddelzeit verkürzen, damit das nächste Zeitfenster pünktlich starten kann.",
          p3:
            "Zeigt die Vorhersage unsichere Winde oder Gewitter, pausieren wir die Ausfahrten und buchen kostenlos um. Alkohol oder andere berauschende Mittel vor oder während der Ausfahrt sind nicht erlaubt.",
          b1: "Die Ausrüstung muss gespült und unbeschädigt zurückgegeben werden; Reparaturen berechnen wir zum Selbstkostenpreis.",
          b2: "Gruppenbuchungen erfordern 25 % Anzahlung, die 48 Stunden vor Start nicht mehr erstattbar ist.",
          b3: "Geführte Touren passen Routen bei Bedarf auf dem Wasser an, um die Sicherheit zu gewährleisten.",
        },
        refund: {
          title: "Rückerstattungsrichtlinie",
          eyebrow: "Fair und flexibel",
          p1:
            "Pläne ändern sich – kein Problem. Storniere bis 24 Stunden vorher für volle Rückerstattung oder verschiebe auf ein zukünftiges Datum (gültig für eine Saison).",
          p2:
            "Innerhalb von 24 Stunden stellen wir 50 % Guthaben für deinen nächsten Paddeltermin aus. Stornierungen am selben Tag sind nicht erstattbar, außer das Wetter macht den Start unsicher.",
          p3:
            "Rückzahlungen treffen in der Regel nach 3–5 Werktagen ein – je nach Zahlungsanbieter. Schreib an wayli@wayli.eu, wenn es länger dauert.",
          b1: "Gutscheine können einmal übertragen werden und behalten ihr ursprüngliches Ablaufdatum.",
          b2: "Wetterbedingte Verschiebungen kannst du neu buchen oder voll erstatten lassen – du entscheidest.",
          b3: "Nichterscheinen wird voll berechnet, damit wir Personal und Ausrüstung verlässlich bereitstellen können.",
        },
      },
    },
    profilePage: {
      hero: {
        eyebrow: "Willkommen zurück",
        fallbackName: "Freund",
        actions: {
          book: "Fahrt buchen",
          edit: "Profil bearbeiten",
        },
        metrics: {
          upcoming: "Bevorstehende Ausfahrten",
          completed: "Abgeschlossene Fahrten",
          loyalty: "Treuebonus-Fortschritt",
        },
        loyalty: {
          title: "Glow Club Fortschritt",
          description: "{completed} von {goal} Fahrten geschafft — noch {remaining} bis zu deinem 20-€-Rabatt!",
          ready: "Du hast alle {goal} Fahrten geschafft – löse jetzt deinen 20-€-Rabatt ein!",
          frozen: "Gutschein bereit – nutze ihn, um wieder Stempel zu sammeln.",
          redeem: "Belohnung einlösen",
          voucherTitle: "Gutschein freigeschaltet!",
          voucherHint: "Nutze diesen Code beim Checkout für 20 € Rabatt.",
        },
      },
      form: {
        fields: {
          name: "Vollständiger Name",
          email: "E-Mail",
        },
        actions: {
          cancel: "Abbrechen",
          save: "Änderungen speichern",
        },
      },
      edit: {
        title: "Profildetails bearbeiten",
        lead:
          "Halte deine Kontaktdaten aktuell, damit wir dich zu deinen Abenteuern erreichen können.",
        fields: {
          name: "Name",
          phone: "Telefonnummer",
          phonePlaceholder: "Telefonnummer",
          countryCode: "Ländervorwahl",
        },
        saveLoading: "Speichere...",
        save: "Profil speichern",
        validation: {
          nameRequired: "Name ist erforderlich.",
          nameLength: "Name darf maximal 30 Zeichen haben.",
          phone: "Telefonnummer muss im internationalen Format sein (z. B. +43123456789).",
        },
      },
      status: {
        updated: "Profil erfolgreich aktualisiert.",
        updateError: "Profiländerungen konnten nicht gespeichert werden.",
      },
      password: {
        title: "Passwort ändern",
        lead: "Schütze dein Konto, indem du hier dein Passwort aktualisierst.",
        show: "Passwort anzeigen",
        hide: "Passwort verbergen",
        fields: {
          current: "Aktuelles Passwort",
          new: "Neues Passwort",
          confirm: "Neues Passwort bestätigen",
        },
        validation: {
          required: "Bitte fülle alle Felder aus, bevor du speicherst.",
          length: "Verwende mindestens 9 Zeichen für dein neues Passwort.",
          complexity: "Nutze einen Großbuchstaben, eine Zahl und ein Sonderzeichen.",
          match: "Neues Passwort und Bestätigung müssen übereinstimmen.",
          different: "Neues Passwort darf nicht mit dem aktuellen identisch sein.",
          auth: "Bitte melde dich erneut an.",
        },
        save: "Passwort aktualisieren",
        saveLoading: "Aktualisiere...",
        hint: "Verwende mindestens 9 Zeichen sowie Großbuchstaben, Zahlen und Sonderzeichen.",
        status: {
          updated: "Passwort erfolgreich aktualisiert.",
          error: "Dein Passwort konnte nicht aktualisiert werden.",
        },
      },
      sections: {
        account: {
          title: "Kontodetails",
          edit: "Bearbeiten",
        },
        upcoming: {
          title: "Bevorstehende Buchungen",
          seeCalendar: "Kalender anzeigen",
          reschedule: "Umbuchen",
          cancel: "Stornieren",
          empty: "Noch keine Buchungen. Zeit, die nächste Paddelrunde zu planen!",
          loading: "Deine Buchungen werden geladen...",
          error: "Deine Buchungen konnten gerade nicht geladen werden. Bitte versuche es bald erneut.",
          authRequired: "Bitte melde dich erneut an, um Buchungen zu verwalten.",
          nightLabel: "Nachtbuchung",
          dayLabel: "Tagesbuchung",
          eventLabel: "Eventbuchung",
          rentalLabel: "Mietbuchung",
          qr: "QR anzeigen",
          qrFallback: "Buchung",
          qrTitle: "QR für Abholung & Rückgabe",
          qrLead:
            "Zeige diesen QR bei Abholung und Rückgabe, damit das Team deine Ausrüstung ausgeben oder zurücknehmen kann.",
          qrLoading: "Dein QR wird erstellt...",
          qrAlt: "Buchungs-QR",
          qrExpires: "Gültig bis",
          qrError: "QR-Code konnte nicht erstellt werden.",
          rescheduleInvalid: "Wähle ein gültiges Datum und eine gültige Uhrzeit.",
          rescheduleOutsideHours:
            "Wähle einen gültigen Mietzeitraum innerhalb der verfügbaren Öffnungszeiten dieses Standorts.",
          rescheduleUnavailable:
            "Dieses Zeitfenster ist für deine ausgewählte Ausrüstung nicht verfügbar. Bitte wähle eine andere Uhrzeit.",
          rescheduleError:
            "Diese Buchung konnte nicht umgebucht werden. Bitte versuche ein anderes Zeitfenster.",
          availabilityError:
            "Die Verfügbarkeit konnte nicht geprüft werden. Bitte versuche es erneut.",
          availabilityChecking: "Verfügbarkeit wird geprüft…",
          availabilityAvailable:
            "Gute Nachrichten! Deine ausgewählte Ausrüstung ist verfügbar.",
          availabilityUnavailable:
            "Ein Teil der Ausrüstung ist nicht verfügbar. Bitte versuche ein anderes Zeitfenster.",
          rescheduleTitle: "Buchung umbuchen",
          rescheduleLead: "Wähle ein neues Zeitfenster für {type} bei {location}.",
          saveReschedule: "Änderungen speichern",
          saveRescheduleLoading: "Speichere...",
          cancelTitle: "Buchung stornieren",
          cancelLead: "{type} am {date} um {time} stornieren?",
          cancelLoading: "Storniere…",
          confirmCancel: "Buchung stornieren",
          cancelNote:
            "Hinweis: Stornierungen innerhalb von 24 Stunden können gebührenpflichtig sein.",
          cancelError:
            "Diese Buchung konnte gerade nicht storniert werden. Bitte versuche es erneut.",
          calendar: {
            title: "Buchungskalender",
            prevMonth: "Vorheriger Monat",
            nextMonth: "Nächster Monat",
            hint: "Wähle ein Datum, um deine Buchung anzusehen, umzubuchen oder zu stornieren.",
            empty: "An diesem Tag gibt es keine Buchungen.",
            pickDay: "Wähle ein Datum, um die geplanten Buchungen zu sehen.",
            prompt: "Tag auswählen",
            days: {
              mon: "Mo",
              tue: "Di",
              wed: "Mi",
              thu: "Do",
              fri: "Fr",
              sat: "Sa",
              sun: "So",
            },
          },
        },
        past: {
          title: "Vergangene Mieten",
          bookAgain: "Nochmal buchen",
          empty: "Deine abgeschlossenen Fahrten erscheinen hier.",
        },
        payments: {
          title: "Zahlungsmethoden",
          add: "Neu hinzufügen",
          remove: "Entfernen",
          expiry: "Gültig bis {expiry}",
          empty: "Keine gespeicherten Zahlungsmittel.",
          addTitle: "Zahlungsmethode hinzufügen",
          addLead: "Füge eine Karte hinzu, damit der Checkout schnell und einfach bleibt.",
          addConfirm: "Karte hinzufügen",
          validationNumber: "Bitte gib eine gültige Kartennummer (12–19 Ziffern) ein.",
          validationExpiry: "Bitte gib das Ablaufdatum im Format MM/JJ ein.",
          validationCvv: "Bitte gib einen gültigen CVC (3–4 Ziffern) ein.",
          fields: {
            cardNumber: "Kartennummer",
            expiry: "Ablauf (MM/JJ)",
            cvv: "CVC",
          },
          placeholders: {
            cardNumber: "1234 5678 9012 3456",
          },
        },
        invoices: {
          title: "Rechnungen",
          empty: "Noch keine Rechnungen. Nach deiner Ausfahrt erscheinen sie hier.",
        },
        receipts: {
          title: "Belege",
          refresh: "Aktualisieren",
          loading: "Deine Belege werden geladen...",
          error: "Deine Belege konnten gerade nicht geladen werden. Bitte versuche es bald erneut.",
          downloadFailed: "Beleg konnte nicht heruntergeladen werden.",
          downloading: "Lade herunter…",
          download: "Herunterladen",
          unknownLocation: "Beleg",
          bookingId: "Buchung",
          empty:
            "Noch keine Belege. Nach der Zahlung deiner Buchung erscheinen sie hier.",
        },
      },
      motivation: {
        title: "Motivationsstation",
        subtitle: "Wähle eine Stimmung und hol dir den Antrieb für deine nächste Ausfahrt.",
        categories: {
          sup: "SUP-Feeling",
          kayak: "Kajak-Flow",
          swim: "Schwimmenergie",
        },
        quotes: {
          sup: [
            {
              text: "Das Board bewegt sich nur, wenn du es tust – steh aufrecht, atme tief, gleite los.",
              author: "Wayli Team",
            },
            {
              text: "Balance bedeutet nicht stillzustehen, sondern jede Welle mitzunehmen.",
              author: "Unbekannt",
            },
            {
              text: "Sonnenaufgang-Schläge, Sonnenuntergang-Lächeln – SUP verankert deinen Tag in Freude.",
              author: "SUP-Community",
            },
          ],
          kayak: [
            {
              text: "Lass dich von der Strömung leiten – paddle mit Herz und Ziel.",
              author: "Flussguide",
            },
            {
              text: "Jeder Schlag schreibt eine Geschichte aufs Wasser. Schreib deine weiter.",
              author: "Kajak-Community",
            },
            {
              text: "Ob ruhiges Wasser oder Wellen – das Kajak folgt deinem Mut.",
              author: "Wayli Team",
            },
          ],
          swim: [
            {
              text: "Das Wasser holt dich genau da ab, wo du bist – tauch ein und sei präsent.",
              author: "Freiwasser-Community",
            },
            {
              text: "Atme, Kick, Zug, wiederholen – Fortschritt ist nur Rhythmus in Bewegung.",
              author: "Schwimmcoach",
            },
            {
              text: "Mit jeder Bahn stärker, mit jedem Gleiten ruhiger.",
              author: "Wayli Team",
            },
          ],
        },
      },
      quickActions: {
        title: "Schnellaktionen",
        editProfile: "Profil bearbeiten",
        changePassword: "Passwort ändern",
        logout: "Abmelden",
      },
      actions: {
        cancel: "Doch nicht",
        keep: "Buchung behalten",
        closeDialog: "Dialog schließen",
      },
      loading: "Dein Profil wird geladen...",
      error: {
        loadFailed:
          "Dein Profil konnte nicht geladen werden. Bitte melde dich erneut an.",
        missing: "Deine Profildaten konnten nicht abgerufen werden.",
        loginAgain: "Zurück zum Login",
      },
    },
    admin: {
      nav: {
        label: "Admin-Navigation",
        title: "Wayli Owner",
        subtitle: "Kontrollraum",
      },
      actions: {
        activate: "Aktivieren",
        addLocation: "Standort hinzufügen",
        addPartner: "Partner hinzufügen",
        adminNote: "Admin-Notiz",
        cancel: "Abbrechen",
        close: "Schließen",
        deactivate: "Deaktivieren",
        delete: "Löschen",
        deleteLocation: "Löschen",
        deletePartner: "Löschen",
        edit: "Bearbeiten",
        editLocation: "Bearbeiten",
        hideDetails: "Details ausblenden",
        next: "Weiter",
        prev: "Zurück",
        refreshLocations: "Liste aktualisieren",
        refund: "Rückerstatten",
        resetPin: "PIN zurücksetzen",
        save: "Speichern",
        search: "Suchen",
        viewDetails: "Details",
      },
      events: {
        eyebrow: "Eventverwaltung",
        heading: "Events",
        add: "Event hinzufügen",
        template: "Vorlage",
        chooseTemplate: "Vorlage wählen",
        templatesLoading: "Vorlagen werden geladen...",
        applyTemplate: "Anwenden",
        saveTemplate: "Als Vorlage speichern",
        updateTemplate: "Vorlage aktualisieren",
        deleteTemplate: "Vorlage löschen",
        title: "Titel",
        location: "Standort",
        chooseLocation: "Standort wählen",
        start: "Start",
        end: "Ende",
        repeat: "Wiederholen",
        repeatNone: "Einmalig",
        repeatWeekly: "Wöchentlich",
        repeatBiweekly: "Alle 2 Wochen",
        repeatMonthly: "Monatlich",
        occurrences: "Termine",
        capacity: "Plätze",
        equipment: "Inventarartikel",
        chooseEquipment: "Inventarartikel wählen",
        equipmentPerPerson: "Einheiten pro Person",
        price: "Preis",
        image: "Bild",
        upload: "Hochladen",
        uploading: "Wird hochgeladen...",
        selectableEquipment: "Auswählbare Ausrüstung",
        selectableEquipmentHint:
          "Kunden können im Event-Buchungsfenster Mengen aus diesen Inventarartikeln wählen.",
        descriptionEn: "Beschreibung (Englisch)",
        descriptionDe: "Beschreibung (Deutsch)",
        includedEn: "Inklusive Leistungen (Englisch)",
        includedDe: "Inklusive Leistungen (Deutsch)",
        includedHint: "Ein Eintrag pro Zeile",
        map: "Karten-URL",
        selfAdjusting: "Selbstständige Abholung und Rückgabe",
        selfSchedule: "Zeitplan für Selbstabholung",
        selfScheduleHint:
          "Start und Ende definieren den verfügbaren Datumsbereich. Wochentage und Zeitfenster legen fest, wann Kunden Boards abholen und zurückbringen können.",
        bookingWindowFrom: "Von",
        bookingWindowUntil: "Bis",
        active: "Für Buchungen sichtbar",
        preview: "Vorschau",
        previewCard: "Karte auf der Info-Seite",
        previewModal: "Geöffnetes Buchungsfenster",
        previewTitle: "Eventtitel",
        previewDescription: "Eventbeschreibung",
        previewIncluded: "Inklusive Leistungen erscheinen hier",
        previewHidden:
          "Diese Vorschau ist privat. Das Event erscheint erst auf der Info-Seite, wenn „Für Buchungen sichtbar“ aktiviert und gespeichert ist.",
        save: "Event speichern",
        create: "Event erstellen",
        bookedOccurrence: "Dieser Termin hat bereits Teilnehmende.",
        bookedOccurrenceHint:
          "Wenn Datum, Uhrzeit oder Inventarstandort geändert werden, wird ein neuer Termin mit leerer Teilnehmerliste erstellt. Der ursprüngliche Termin und seine Buchungen bleiben im Verlauf erhalten.",
        loading: "Events werden geladen...",
        empty: "Es wurden noch keine Events erstellt.",
        upcoming: "Kommende Termine",
        upcomingHint:
          "Jeder Termin hat ein eigenes Datum, eine eigene Kapazität und Teilnehmerliste.",
        history: "Eventverlauf",
        historyHint:
          "Vergangene Termine behalten ihre eigene Konfiguration und Teilnehmerdaten.",
        scheduleAnother: "Weiteren Termin planen",
        inventoryNotConfigured: "Inventar nicht konfiguriert",
        unitsPerPersonShort: "Einheit/Person",
        people: "Personen",
        personName: "Name",
        personEmail: "E-Mail",
        personPhone: "Telefon",
        addPerson: "Person hinzufügen",
        noAttendees: "Noch niemand hat dieses Event gebucht.",
        removePerson: "Entfernen",
        paidBookingNote:
          "Website-Buchung. Beim Entfernen wird die Buchung storniert; Rückerstattungen werden separat unter Buchungen verwaltet.",
      },
    },
    bookingClosed: {
      eyebrow: "Wayli-Status",
      title: "Wir haben derzeit geschlossen",
      lead:
        "Das Wasser ist ruhig, und wir machen eine kurze Pause zum Durchatmen. Deine bestehenden Buchungen bleiben gültig, und bald öffnen wir wieder mit neuen Zeitfenstern.",
      badges: {
        bookingsPaused: "Buchungen pausiert",
        paymentsDisabled: "Zahlungen deaktiviert",
        temporarilyClosed: "Vorübergehend geschlossen",
      },
    },
    googleMap: {
      consent: {
        eyebrow: "Funktionale Inhalte",
        title: "Die Karte bleibt aus, bis du sie erlaubst",
        description:
          "Wayli kann eine Live-Karte von Google erst anzeigen, nachdem du funktionale Cookies aktiviert hast. Die Standortliste und direkte Google-Maps-Links bleiben trotzdem nutzbar.",
        cta: "Cookies aktivieren",
        settings: "Cookie-Einstellungen",
      },
      error: {
        unavailable:
          "Karte nicht verfügbar. Prüfe die Referrer-Beschränkungen des Google-Maps-API-Schlüssels.",
        missingKey: "Google-Maps-API-Schlüssel fehlt.",
      },
      loading: "Karte wird geladen...",
    },
  },
};

export default translations;
